<template>
    <header>
		<div class="preloader" v-if="loading">
			<div class="circular-spinner">
				<img src="../assets/images/shiba-loading.png">
			</div>
		</div>
		<nav class="x-header js-header-selector navbar navbar-expand-lg -anon -sticky">
		<div class="container-fluid -inner-container">
			<div class="">
				<button type="button" class="btn bg-transparent p-0 x-hamburger" data-toggle="modal" data-target="#themeSwitcherModal">
						<span></span>
						<span></span>
						<span></span>
				</button>
			</div>
			<div id="headerBrand">
				<router-link to="/" class="navbar-brand">
					<img class="-logo -default" src="../assets/images/logo.png" alt="XXMAC">
					<img class="-logo -invert"
						src="../assets/images/logo.png"
						alt="XXMAC">
				</router-link>
			</div>
			<div class="x-menu">
				<div class="-menu-container">
					<router-link to="/provider" :class="{'-menu-link':true,'active':(mainMenu === 'provider')?true:false}"><span>Slot</span></router-link>
					<router-link to="/casino" :class="{'-menu-link':true,'active':(mainMenu === 'casino')?true:false}"><span>คาสิโน</span></router-link>
          <a href="/playsport" target="_blank" class="-menu-link"><span>สปอร์ต</span></a>
					<router-link to="/event" :class="{'-menu-link':true,'active':(mainMenu === 'event')?true:false}"><span>สิทธิพิเศษ</span></router-link>
					<router-link to="/promotion" :class="{'-menu-link':true,'active':(mainMenu === 'promotion')?true:false}"><span>โปรโมชั่น</span></router-link>
          <router-link to="/cashback" :class="{'-menu-link':true,'active':(mainMenu === 'cashback')?true:false}"><span>คืนยอดเล่น</span></router-link>
          <router-link to="/continue" :class="{'-menu-link':true,'active':(mainMenu === 'continue')?true:false}"><span>ฝากต่อเนื่อง</span></router-link>
          <router-link to="/partner" :class="{'-menu-link':true,'active':(mainMenu === 'partner')?true:false}"><span>พันธมิตร</span></router-link>
          <!-- <router-link to="/rewards" :class="{'-menu-link':true,'active':(mainMenu === 'rewards')?true:false}"><span>แลกของรางวัล</span></router-link> -->
				</div>
			</div>

			<div id="headerContent">
				<div class="d-flex" v-if="!user.key">
					<a href="#loginModal" class="-btn-header-register btn f-sm-6 f-7 mr-1 mr-sm-3" data-toggle="modal" data-target="#registerModal">
						สมัครสมาชิก
					</a>
					<a href="#loginModal" class="-btn-header-login btn f-sm-6 f-7" data-toggle="modal" data-target="#loginModal">
						เข้าสู่ระบบ
					</a>
				</div>
				<div class="x-logged" v-else>
          <div class="x-ranking-entrance">
            <router-link to="/rewards" class="-link-wrapper">
                <div class="-image-wrapper">
                    <img class="img-fluid -ic-right-star-rank" src="../assets/images/coins.png" alt="XXMAC แลกของรางวัล">
                </div>
                <div class="-text-wrapper">{{numberWithCommas2(user.coin)}}</div>
            </router-link>
        </div>
        <button
          v-if="hasActivePayBridgeTask"
          type="button"
          class="paybridge-task-button"
          @click.stop="reopenPayBridgeTask()"
        >
          <span class="paybridge-task-dot"></span>
          <span class="paybridge-task-copy">
            <strong>PayBridge</strong>
            <small>{{ paybridgeAcknowledged ? 'รอสลิป' : 'ทำรายการต่อ' }} {{ paybridgeTaskRemainingText }}</small>
          </span>
        </button>
				<div class="-balance-container">
					<div class="-text-username">
						{{user.mobile}}
					</div>

												
					<div class="-user-balance js-user-balance f-sm-6 f-7 ">
						<div class="-inner-box-wrapper">
							<img class="img-fluid -ic-coin" src="../assets/images/ez-slot-ic-coin.png" alt="customer image">
							<span id="customer-balance" class="js-customer-balance">
					<span class="text-green-lighter">{{getCredit()}}</span>

				</span>
						</div>

						
				<button type="button" id="btn-customer-balance-reload" class="-btn-balance  " @click="reloadBalance()">
					<i :class="{'fas fa-sync-alt f-9':true,'fa-spin':fa_spin}"></i>
				</button>
					</div>
				</div>

					<div class="-deposit-container d-none d-xl-block">
						<a href="#deposit" class="text-white js-account-approve-aware btn -btn-deposit" data-toggle="modal" data-target="#depositModal" @click="checkPromotions()">
							<div class="f-7">ฝากเงิน</div>
						</a>
					</div>

					<div class="-withdraw-container d-none d-xl-block">
						<a href="#withdraw" class="text-white js-account-approve-aware btn -btn-withdraw" data-toggle="modal" data-target="#withdrawModal" @click="moveCreditToWallet()">
							<div class="f-7">ถอนเงิน</div>
						</a>
					</div>
					<div class="-profile-container">
						<a href="#account" data-toggle="modal" data-target="#accountModal" class="-btn-wrapper">
							


              <div class="x-profile-image">
					<img class="img-fluid -profile-image" :src="getLevelImage()" alt="customer image">
				</div>

              <div class="d-flex flex-column text-center">
								<span class="-profile-name">{{user.code}}</span>
								<span style="color: #fff; font-size: 11px;">(LV.{{(user.level)?user.level:1}})</span>
							</div>
						</a>
						<div class="d-xl-none d-block">
							<div :class="{'js-ez-logged-sidebar':true, '-open':this.accountOpen }">

				<div class="x-profile-image">
					<a href="javascript:void(0)" @click="showTabAccount()">
					<img class="img-fluid -profile-image d-none d-xl-block" :src="getLevelImage()" alt="customer image">
          <span class="-profile-name" style="font-size:12px;color:#fff;padding-left: 5px;">บัญชี</span>
					</a>
				</div>
							</div>
							<div :class="{'x-menu-account-list-sidebar':true,'-open':this.accountOpen}">
								

				<div class="x-modal-account-menu-mobile ">
    <div class="-modal-profile-mobile d-xl-none d-block">
        <div class="text-right">
            <i class="fas fa-times f-5 js-close-account-sidebar" @click="showTabAccount()"></i>
        </div>

        


<div class="x-profile-image">
    <img class="img-fluid -profile-image" style="width:100px;max-width: 100px;" :src="getLevelImage2()" alt="customer image">
</div>

        <div class="-balance-container">
            
    <div class="-text-username" style="color: #000;">
        {{user.code}} (LV. {{(user.level)?user.level:1}})
    </div>
    <div class="-user-balance js-user-balance f-sm-6 f-7 ">
        <div class="-inner-box-wrapper">
           <img class="img-fluid -ic-coin" src="../assets/images/ez-slot-ic-coin.png" alt="customer image">
            <span id="customer-balance" class="js-customer-balance">
    <span class="text-green-lighter">{{getCredit()}}</span>
</span>
        </div>
        
<button type="button" id="btn-customer-balance-reload" class="-btn-balance  " @click="reloadBalance()">
    <i :class="{'fas fa-sync-alt f-9':true,'fa-spin':fa_spin}"></i>
</button>
    </div>
        </div>
    </div>

        
    <div class="-transaction-button-wrapper">
                    
            <a href="javascript:void(0);" class="x-transaction-button-v2 -in-sidebar -deposit js-close-account-sidebar" data-toggle="modal" data-target="#depositModal" @click="checkPromotions()">
                <img class="img-fluid -icon" src="../assets/images/icdeposit.png" alt="ฝากเงิน">
                <div class="-text-wrapper">
                    <span class="-title">ฝากเงิน</span>
                    <span class="-sub-title">Deposit</span>
                </div>
            </a>
                    
            <a href="javascript:void(0);" class="x-transaction-button-v2 -in-sidebar -withdraw js-close-account-sidebar" data-toggle="modal" data-target="#withdrawModal"  @click="moveCreditToWallet()">
                <img class="img-fluid -icon" src="../assets/images/icwithdraw.png" alt="ถอนเงิน">
                <div class="-text-wrapper">
                    <span class="-title">ถอนเงิน</span>
                    <span class="-sub-title">Withdraw</span>
                </div>
            </a>
            </div>


    
    <ul class="navbar-nav">
                                    <li class="nav-item -account-profile">
                    <button type="button" class="nav-link js-close-account-sidebar " data-toggle="modal" data-target="#accountModalMobile">
                        <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-user.png" alt="ic-menu-user">
                        <span class="-text-menu">
                            ข้อมูลบัญชี
                        </span>
                    </button>
                </li>
                                                <!-- <li class="nav-item -coupon">
                    <button type="button" class="nav-link js-close-account-sidebar js-account-approve-aware" data-toggle="modal" data-target="#couponModalMobile">
                        <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-coupon.png" alt="ic-menu-coupon">
                        <span class="-text-menu">
                            ใช้คูปอง
                        </span>
                    </button>
                </li> -->
                <li class="nav-item -join-promotion">
                    <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('promotion','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-promotion.png" alt="ic-menu-promotion">
                        <span class="-text-menu">
                            โปรโมชั่นที่เข้าร่วม
                        </span>
                    </button>
                </li>
                <li class="nav-item -join-promotion">
                    <button type="button" class="nav-link js-close-account-sidebar " @click="gotoPage('partner','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/partner.png" alt="ic-menu-bonus">
                        <span class="-text-menu">
                            พันธมิตร
                        </span>
                    </button>
                </li>
                <li class="nav-item -join-promotion">
                    <button type="button" class="nav-link js-close-account-sidebar " @click="gotoPage('cashback','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/cashback.png" alt="ic-menu-bonus">
                        <span class="-text-menu">
                            คืนยอดเล่น
                        </span>
                    </button>
                </li>
                 <li class="nav-item -join-promotion">
                    <button type="button" class="nav-link js-close-account-sidebar " @click="gotoPage('continue','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/continue.png" alt="ic-menu-bonus">
                        <span class="-text-menu">
                            ฝากต่อเนื่อง
                        </span>
                    </button>
                </li>
                <li class="nav-item -account-provider">
                    <button type="button" class="nav-link js-close-account-sidebar " @click="gotoPage('rewards','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/redeem-rewards.png" alt="ic-menu-provider">
                        <span class="-text-menu">
                            แลกของรางวัล
                        </span>
                    </button>
                </li>
                <li class="nav-item -account-provider">
                    <button type="button" class="nav-link js-close-account-sidebar " @click="gotoPage('history','themeSwitcherModal')">
                        <img class="img-fluid -icon-image" src="../assets/images/history.png" alt="ic-menu-provider">
                        <span class="-text-menu">
                            ประวัติธุรกรรม
                        </span>
                    </button>
                </li>
                                                <li class="nav-item -logout">
                    <a href="javascript:void(0)" @click="confirmLogout" class="nav-link js-require-confirm" data-title="ต้องการออกจากระบบ ?">
                        <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-logout.png" alt="ic-menu-logout">
                        <span class="-text-menu">
                        ออกจากระบบ
                    </span></a>
                </li>
                        </ul>
</div>
								<div class="-overlay"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
    	</div>
    	</nav>
			

		<resetPasswordModal></resetPasswordModal>

		<div class="x-modal modal -v2 -with-half-size" id="loginModal" tabindex="-1" role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
			<div class="modal-dialog -modal-size  -dialog-in-tab -register-index-dialog" role="document" style="padding-top: 100px; height: 100%;">
				<div class="modal-content -modal-content">
						<button type="button" class="close f-1 -in-tab" data-dismiss="modal" aria-label="Close">
							<i class="fas fa-times"></i>
						</button>
						<div class="x-modal-account-security-tabs -v2">
							<button type="button" class="-btn -register js-modal-account-security-tab-button" @click="showModal('loginModal','registerModal')">
								สมัครสมาชิก
							</button>
							<button type="button" class="-btn -login js-modal-account-security-tab-button -active" data-modal-target="#loginModal">
								เข้าสู่ระบบ
							</button>
						</div>

			<div class="modal-body -modal-body" style="top: 0px;">
				<div class="x-modal-separator-container x-login-form">
			<div class="-top ">
						<div data-animatable="fadeInModal" class="animated fadeInModal">
					<div class="-img-container text-center">
				<img class="-ic-login img-fluid lazyloaded" alt="login" width="60" height="60" data-src="../assets/images/ez-slot-ic_login.png?v=1" src="../assets/images/ez-slot-ic_login.png?v=1">
								
					</div>
					<form @submit.prevent="login" class="js-login-form">
						<div class="-x-input-icon mt-3 mb-3 flex-column">
		
				<img class="-icon img-fluid lazyloaded" alt="login_mobile" width="15" height="15" data-src="../assets/images/ez-slot-ic_phone.png?v=1" src="../assets/images/ez-slot-ic_phone.png?v=1">
								<input type="number" id="login_mobile" v-model="login_mobile" inputmode="text" name="username" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" class="form-control x-form-control" placeholder="เบอร์โทรศัพท์">
						</div>
						<div class="-x-input-icon flex-column">
		
				<img class="-icon img-fluid lazyloaded" alt="password" width="15" height="15" data-src="../assets/images/ez-slot-ic-lock-input.png?v=1" src="../assets/images/ez-slot-ic-lock-input.png?v=1">
								<input type="password" id="login_password" v-model="login_password" class="form-control x-form-control" placeholder="รหัสผ่าน">
						</div>
						<div class="x-reset-pw-text-container -v2">
							<a href="#resetPassword" data-dismiss="modal" data-toggle="modal" data-target="#resetPasswordModal">
								<u>ลืมรหัสผ่าน</u>
							</a>
						</div>

						<div class="text-center">
							<button type="submit" class="btn btn-primary -submit">
								<span>เข้าสู่ระบบ</span>
							</button>
						</div>
					</form>
				</div>
				</div>
		<div class="-bottom ">
						<div data-animatable="fadeInModal" class="animated fadeInModal">
									
										<div class="x-admin-contact ">
							<span class="x-text-with-link-component">
		<label class="-text-message ">พบปัญหา</label>
		<a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
			<u>ติดต่อฝ่ายบริการลูกค้า</u>
		</a>
	</span>
						</div>
								</div>
				</div>
	</div>
					</div>
				</div>
			</div>
		</div>

		
		<div class="x-modal modal -v2 -with-half-size show" id="registerModal" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#registerModal">
			<div class="modal-dialog -modal-size  -dialog-in-tab -register-index-dialog" role="document" style="padding-top: 100px; height: 100%;">
    <div class="modal-content -modal-content">
                    <button type="button" class="close f-1 -in-tab" data-dismiss="modal" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
                        <div class="x-modal-account-security-tabs -v2">
    <button type="button" class="-btn -register js-modal-account-security-tab-button -active" data-modal-target="#registerModal">
        สมัครสมาชิก
    </button>
    <button type="button" class="-btn -login js-modal-account-security-tab-button" @click="showModal('registerModal','loginModal')">
        เข้าสู่ระบบ
    </button>
</div>
                    <div class="modal-body -modal-body" style="top: 0px;">
                                <div class="x-form-register -register mt-0">
                <div class="row -animatable-container">
                    <div class="col order-1 text-center pr-lg-0 mx-auto js-slide-term-and-condition-content x-slide-left-content x-slide-left-content-term -hide">
                        <div class="-fake-inner-body">
                            <div class="-term-and-condition-content js-term-and-condition">
                                <div class="x-term-and-condition">
								<div class="text-center d-lg-none">
									<a href="#close-term-and-condition" class="js-get-term-and-condition btn -submit btn-primary my-0 my-lg-3 f-5 f-lg-6">
										<span>ย้อนกลับ</span>
									</a>
								</div>
								</div>
                            </div>
                        </div>
                    </div>

                    <div data-animatable="fadeInRegister" data-offset="0" class="col order-lg-2 order-0 -form animated fadeInRegister">
                        <div class="x-modal-separator-container ">
    <div class="-top ">
                <div class="-fake-inner-body">
            
			<div class="x-step-register">
				<div class="px-0 m-auto -container-wrapper">
					<div :class="{ '-step-box-outer': true, 'step-active': step==1 || step==1.2 || step ==4 }"></div>
					<div :class="{ '-step-box-outer': true, 'step-active': step==2 || step ==4 }"></div>
					<div :class="{ '-step-box-outer': true, 'step-active': step==3 || step ==4 }"></div>
				</div>
			</div>

      <div class="-img-container">
        <picture><source type="image/webp" :srcset="(step==4)?require('../assets/images/success.png'):require('../assets/images/ic_register.webp')"><source type="image/png?v=1" :srcset="(step==4)?require('../assets/images/success.png'):require('../assets/images/ic_register.png')"><img alt="สมัครสมาชิก" class="img-fluid -ic-register" width="80" height="80" :src="(step==4)?require('../assets/images/success.png'):require('../assets/images/ic_register.png')"></picture>
      </div>
      <template v-if="step==1">
        <div class="-x-input-icon mb-3 text-center">
          <img class="-icon" alt="XXMAC" width="15" height="15" src="../assets/images/ic_phone.png?v=1">
          <input type="number" v-model="mobile" id="mobile" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" class="x-form-control form-control" placeholder="เบอร์โทรศัพท์" aria-describedby="basic-addon1">
        </div>
        <div class="m-auto -term-and-condition-check-box">
        </div>
        <div class="text-center">
          <button type="button" class="btn  -submit js-submit-accept-term btn-primary mt-lg-3 mt-0" @click="checkPhone()">
            ยืนยัน
          </button>
        </div>
      </template>
      <template v-if="step==1.2">
        <p class="mt-1 text small" style="text-align: center;">รหัส OTP จะส่งไปที่เบอร์มือถือของท่าน
        </p>
        <p class="mt-1 text small" style="text-align: center;">เบอร์ {{mobileFormat()}}
        </p>
        <div class="form-group">
            <input type="text" v-model="otp" class="form-control mb-3" placeholder="กรอกรหัส OTP จากเบอร์มือถือของท่าน"
                id="otp" name="otp" style="text-align: center;" maxlength="4" >
        </div>
        <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
            <p class="text-center">
              <button type="button" class="btn  -submit js-submit-accept-term btn-primary mt-lg-3 mt-0" @click="checkOTP()">
                ยืนยัน OTP
              </button>
            </p>
        </div>
        <p class="mt-1 text small" style="text-align: center;font-size: 12px;" @click="resendOTP()"><i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>&nbsp;รับรหัส OTP ใหม่อีกครั้ง
        </p>
        <a href="javascript:;" @click="step=1" class="previous action-button-previous"><i
                class="fa fa-angle-left" aria-hidden="true" style="color: #eee;"></i>
            ย้อนกลับ</a>
      </template>
			<template v-else-if="step==2">
				<div class="-x-input-icon mb-3 flex-column">
                        <img alt="สมัครสมาชิกเว็บพนันออนไลน์ แทงบอลออนไลน์" class="-icon" width="15" height="15" src="../assets/images/ic-lock-input.png?v=1">
                    <div class="x-password-toggler">
						<input :type="p1" v-model="password" required="required" class="x-form-control form-control" placeholder="ตั้งรหัสผ่าน 6 ตัวอักษรขึ้นไป" autofocus="autofocus" autocomplete="off">
						<i class="-ic fas fa-eye" @click="showpassword('password')"></i>
						<i class="-ic fas fa-eye-slash" @click="hidepassword('password')"></i>
					</div>
                </div>
                <div class="-x-input-icon flex-column">
                    <img alt="สมัครสมาชิกเว็บพนันออนไลน์ แทงบอลออนไลน์" class="-icon" width="15" height="15" src="../assets/images/ic-lock-input.png?v=1">
                    <div class="x-password-toggler">
                        <input :type="p2" required="required" v-model="password2" class="x-form-control form-control" placeholder="พิมพ์รหัสผ่านอีกครั้ง" autocomplete="off">
                        <i class="-ic fas fa-eye" @click="showpassword('password2')"></i>
    					<i class="-ic fas fa-eye-slash" @click="hidepassword('password2')"></i>
					</div>
                </div>
				<div class="m-auto -term-and-condition-check-box">
				</div>
				<div class="text-center">
					<button type="button" class="btn  -submit js-submit-accept-term btn-primary mt-lg-3 mt-0" @click="checkPassword()">
						ยืนยัน
					</button>
				</div>
			</template>
			<template v-else-if="step==3">
				<div id="card-bank-info">
					<div class="text-center">
						<div class="my-3 js-bank-select-container">
							<div class="x-bank-choices-type ">
								<div class="-outer-wrapper">
									<input type="radio" class="-input-radio" id="bank-acc-truewallet" name="customer_bank_account[bank]" value="truewallet" @change="selectBank('truewallet')">
									<label class="-label" for="bank-acc-truewallet">
										<img class="-logo" src="../assets/images/bank/tmw.png" alt="TrueMoney Wallet">
										<i class="fas fa-check"></i>
									</label>
									<input type="radio" class="-input-radio" id="bank-acc-61654879238" name="customer_bank_account[bank]" value="6">
									<label class="-label" for="bank-acc-61654879238">
																	<img class="-logo"  src="../assets/images/bank_register/scb.png" alt="" @click="selectBank('scb')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-71654879238" name="customer_bank_account[bank]" value="7">
									<label class="-label" for="bank-acc-71654879238">
																	<img class="-logo" src="../assets/images/bank_register/kbank.png" alt="" @click="selectBank('kbank')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-81654879238" name="customer_bank_account[bank]" value="8">
									<label class="-label" for="bank-acc-81654879238">
																	<img class="-logo" src="../assets/images/bank_register/bangkok.png" alt="" @click="selectBank('bankokbank')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-91654879238" name="customer_bank_account[bank]" value="9">
									<label class="-label" for="bank-acc-91654879238">
																	<img class="-logo" src="../assets/images/bank_register/bay.png" alt="" @click="selectBank('krungsri')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-101654879238" name="customer_bank_account[bank]" value="10">
									<label class="-label" for="bank-acc-101654879238">
																	<img class="-logo" src="../assets/images/bank_register/k.png" alt="" @click="selectBank('kiatnakin')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-111654879238" name="customer_bank_account[bank]" value="11">
									<label class="-label" for="bank-acc-111654879238">
																	<img class="-logo" src="../assets/images/bank_register/cimb.png" alt="" @click="selectBank('cimb')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-121654879238" name="customer_bank_account[bank]" value="12">
									<label class="-label" for="bank-acc-121654879238">
																	<img class="-logo" src="../assets/images/bank_register/ttb.png" alt="" @click="selectBank('ttb')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-141654879238" name="customer_bank_account[bank]" value="14">
									<label class="-label" for="bank-acc-141654879238">
																	<img class="-logo" src="../assets/images/bank_register/uob.png" alt="" @click="selectBank('uob')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-151654879238" name="customer_bank_account[bank]" value="15">
									<label class="-label" for="bank-acc-151654879238">
																	<img class="-logo" src="../assets/images/bank_register/ktb.png" alt="" @click="selectBank('ktb')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-161654879238" name="customer_bank_account[bank]" value="16">
									<label class="-label" for="bank-acc-161654879238">
																	<img class="-logo" src="../assets/images/bank_register/a.png" alt="" @click="selectBank('gsb')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-171654879238" name="customer_bank_account[bank]" value="17">
									<label class="-label" for="bank-acc-171654879238">
																	<img class="-logo" src="../assets/images/bank_register/baac.png" alt="" @click="selectBank('baac')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-181654879238" name="customer_bank_account[bank]" value="18">
									<label class="-label" for="bank-acc-181654879238">
																	<img class="-logo" src="../assets/images/bank_register/stand.png" alt="" @click="selectBank('standard')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-251654879238" name="customer_bank_account[bank]" value="25">
									<label class="-label" for="bank-acc-251654879238">
																	<img class="-logo" src="../assets/images/bank_register/lh.png" alt="" @click="selectBank('lh')">
																<i class="fas fa-check"></i>
									</label>
													<input type="radio" class="-input-radio" id="bank-acc-271654879238" name="customer_bank_account[bank]" value="27">
									<label class="-label" for="bank-acc-271654879238">
																	<img class="-logo" src="../assets/images/bank_register/tos.png" alt="" @click="selectBank('ghbank')">
																<i class="fas fa-check"></i>
									</label>
                            	</div>
        					</div>
    					</div>

						<div class="js-bank-number-and-name-container">
							<div class="-x-input-icon mb-3 flex-column">
								<img src="../assets/images/ic_library_book.png" class="-icon" alt="" width="14">

								<input type="number" v-model="account_no" @blur="checkBankAccount()" required="required" class="x-form-control form-control" placeholder="กรอกเลขบัญชี" autofocus="autofocus" inputmode="text">
							</div>
							<div class="-x-input-icon mb-3 flex-column">
								<img src="../assets/images/ic_user_circle.png" class="-icon" alt="" width="16">
								<input type="text"  required="required" class="x-form-control form-control" v-model="firstname" placeholder="กรอก ชื่อ">
							</div>
							<div class="-x-input-icon mb-3 flex-column">
								<img src="../assets/images/ic_user_circle.png" class="-icon" alt="" width="16">
								<input type="text"  required="required" class="x-form-control form-control" v-model="lastname" placeholder="กรอก นามสกุล">
							</div>
							<div class="-text-hint col-sm-10 m-auto d-block">กรอกข้อมูลให้ครบถ้วนและถูกต้องมิฉะนั้นท่านจะไม่สามารถถอนเงินได้</div>

							<div class="text-center">
								<button type="button" class="btn  -submit btn-primary my-lg-3 my-0" @click="register()">
									ยืนยัน
								</button>
							</div>
						</div>
					</div>
                </div>
			</template>
			<template v-if="step==4">
				<div class="-x-input-icon mb-3 text-center" style="justify-content: center;">
					<h2 class="-game-title h5 d-lg-none">
						สมัครสมาชิกสำเร็จแล้ว
					</h2>
				</div>
				<div class="-x-input-icon mb-3 text-center">
					<input type="text" :value="'Username: '+mobile" readonly class="x-form-control form-control" placeholder="เบอร์โทรศัพท์" aria-describedby="basic-addon1">
				</div>
				<div class="-x-input-icon mb-3 text-center">
					<input type="text" :value="'Password: '+password"  readonly class="x-form-control form-control" placeholder="Password" aria-describedby="basic-addon1">
				</div>
				<div class="m-auto -term-and-condition-check-box">
				</div>
				<div class="text-center">
					<button type="button" class="btn btn-primary -submit" @click="showModal('registerModal','loginModal')">
						เข้าสู่ระบบ
					</button>
				</div>

			</template>
        </div>
        </div>
    <div class="-bottom ">
                        
                    <div class="x-admin-contact text-center ">
                <span class="x-text-with-link-component">
     <label class="-text-message ">พบปัญหา</label>
     <a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
        <u>ติดต่อฝ่ายบริการลูกค้า</u>
    </a>
</span>
            </div>
                </div>
</div>
                    </div>
                </div>
            </div>
                    </div>
    </div>
			</div>
		</div>


	<div class="x-modal modal  x-theme-switcher-v2" id="themeSwitcherModal" tabindex="-1" role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
                            <div class="modal-dialog -modal-size" role="document">
            <div class="modal-content -modal-content">
                                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                                                                <div class="modal-body -modal-body">
    
    <div class="-theme-switcher-container">
                <div class="-inner-header-section">
            <a class="-link-wrapper" href="/">
                <img class="-logo" src="../assets/images/logo.png" alt="XXMAC รวมคาสิโนออนไลน์ บาคาร่าสด สล็อต กีฬา และเครดิตฟรี">
            </a>
        </div>
    
        <div class="-inner-top-body-section">
          <template v-if="user.key">
            <div class="col-6 -wrapper-box">
              <button type="button" class="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal" data-toggle="modal" data-dismiss="modal" data-target="#depositModal"  @click="checkPromotions()">
                <img alt="XXMAC รูปไอคอนฝากเงิน" class="img-fluid -icon-image" src="../assets/images/icdeposit.png">
                <div class="-typo-wrapper">
                  <div class="-title">ฝากเงิน</div>
                  <div class="-sub-title">Deposit</div>
                </div>
              </button>
            </div>
            <div class="col-6 -wrapper-box">
              <button type="button" class="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal" data-toggle="modal" data-dismiss="modal" data-target="#withdrawModal"  @click="moveCreditToWallet()">
                <img alt="XXMAC รูปไอคอนถอนเงิน" class="img-fluid -icon-image" src="../assets/images/icwithdraw.png">
                  <div class="-typo-wrapper">
                    <div class="-title">ถอนเงิน</div>
                    <div class="-sub-title">Withdraw</div>
                  </div>
              </button>
            </div>
          </template>
          <template v-else>
            <div class="col-6 -wrapper-box">
              <button type="button" class="btn -btn-item -top-btn -login-btn " data-toggle="modal" data-dismiss="modal" data-target="#registerModal">
                  <img alt="XXMAC รูปไอคอนสมัครสมาชิก" class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-register.png?v=1">
                      <div class="-typo-wrapper">
                  <div class="-typo ">สมัครเลย</div>
                              </div>
              </button>
            </div>
            <div class="col-6 -wrapper-box">
              <button type="button" class="btn -btn-item -top-btn -login-btn " data-toggle="modal" data-dismiss="modal" data-target="#loginModal">
                  <img alt="XXMAC รูปไอคอนเข้าสู่ระบบ" class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-login.png?v=1">
                  <div class="-typo-wrapper">
                    <div class="-typo ">เข้าสู่ระบบ</div>
                  </div>
              </button>
            </div>
          </template>
          
                    </div>
    
                
        <div class="-inner-center-body-section">
                            <div class="col-6 -wrapper-box">
    
			<a href="javascript:void(0)" @click="gotoPage('event','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
				<img alt="XXMAC รูปไอคอนสิทธิพิเศษ" class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-event.png?v=1">
                    <div class="-typo-wrapper">
                <div class="-typo ">สิทธิพิเศษ</div>
                            </div>
			</a>
                </div>
                            <div class="col-6 -wrapper-box">
			<a href="javascript:void(0)" @click="gotoPage('promotion','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
					<img alt="XXMAC รูปไอคอนโปรโมชั่น" class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-promotion.png?v=1">
                    <div class="-typo-wrapper">
                	<div class="-typo ">โปรโมชั่น</div>
                    </div>
			</a>
                </div>
                <div class="col-6 -wrapper-box">
                    <a href="javascript:void(0)" @click="gotoPage('rewards','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
                      <img alt="XXMAC แลกของรางวัล" class="img-fluid -icon-image" src="../assets/images/redeem-rewards.png?v=1">
                                  <div class="-typo-wrapper">
                              <div class="-typo ">แลกของรางวัล</div>
                                          </div>
                    </a>
                  </div>
                <template v-if="user.key">
                  <div class="col-6 -wrapper-box">
                    <a href="javascript:void(0)" @click="gotoPage('cashback','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
                      <img alt="XXMAC คืนยอด" class="img-fluid -icon-image" src="../assets/images/cashback.png?v=1">
                                  <div class="-typo-wrapper">
                              <div class="-typo ">คืนยอดเล่น</div>
                                          </div>
                    </a>
                  </div>
                  <div class="col-6 -wrapper-box">
                    <a href="javascript:void(0)" @click="gotoPage('continue','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
                      <img alt="XXMAC ฝากต่อเนื่อง" class="img-fluid -icon-image" src="../assets/images/continue.png?v=1">
                                  <div class="-typo-wrapper">
                              <div class="-typo ">ฝากต่อเนื่อง</div>
                                          </div>
                    </a>
                  </div>
                  <div class="col-6 -wrapper-box">
                    <a href="javascript:void(0)" @click="gotoPage('partner','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
                      <img alt="XXMAC ฝากต่อเนื่อง" class="img-fluid -icon-image" src="../assets/images/partner.png?v=1">
                                  <div class="-typo-wrapper">
                              <div class="-typo ">พันธมิตร</div>
                                          </div>
                    </a>
                  </div>
                  <div class="col-6 -wrapper-box">
                    <a href="javascript:void(0)" @click="gotoPage('history','themeSwitcherModal')" class="btn -btn-item -event-button -menu-center -horizontal">
                      <img alt="PUG888 ประวัติธุรกรรม" class="img-fluid -icon-image" src="../assets/images/history.png?v=1">
                                  <div class="-typo-wrapper">
                              <div class="-typo ">ประวัติธุรกรรม</div>
                                          </div>
                    </a>
                  </div>
                </template>
                            <div class="col-6 -wrapper-box">
           <a :href="lineLink" class="btn -btn-item -line-button -menu-center -horizontal" target="_blank" rel="noopener nofollow">
                <img alt="XXMAC รูปไอคอนดูหนัง" class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-line.png?v=1">
                                    
                    <div class="-typo-wrapper">
                <div class="-typo ">Line</div>
                            </div>
            
        </a>
    
                </div>
                    </div>
    

    </div>
                </div>
            </div>
        </div>
    </div>
		<div class="x-modal modal -v2 show" id="accountModal" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-container="#accountModal" aria-modal="true"><div class="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable -modal-big -modal-main-account" role="document">
    <div class="modal-content -modal-content">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
                                <div class="modal-body -modal-body">
                        <div class="x-modal-account-menu">
    <ul class="navbar-nav">
        <li class="nav-item -account-profile active">
            <button type="button" class="nav-link js-close-account-sidebar" data-active-menu="-account-profile">
                <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-user.png" alt="icon user">
                <div class="-text-menu">
                    ข้อมูลบัญชี
                </div>
            </button>
        </li>
                    <!-- <li class="nav-item -coupon ">
                <button type="button" class="nav-link js-close-account-sidebar js-account-approve-aware" data-ajax-account-modal="/account/_ajax_/coupon-apply" data-container="#accountModal" data-active-menu="-coupon">
                    <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-coupon.png" alt="icon coupon">
                    <div class="-text-menu">
                        ใช้คูปอง
                    </div>
                </button>
            </li> -->
        
        <li class="nav-item -join-promotion ">
            <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('promotion','accountModal')">
                <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-promotion.png" alt="icon promotion">
                <div class="-text-menu">
                    โปรโมชั่นที่เข้าร่วม
                </div>
            </button>
        </li>
        <li class="nav-item -join-promotion ">
            <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('event','accountModal')">
                <img class="img-fluid -icon-image" src="../assets/images/ez-theme-switcher-ic-event.png?v=1" alt="icon promotion">
                <div class="-text-menu">
                    สิทธิพิเศษ
                </div>
            </button>
        </li>
            <li class="nav-item -join-promotion ">
                <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('partner','accountModal')">
                    <img class="img-fluid -icon-image" src="../assets/images/partner.png" alt="icon bonus from promotion return by user" width="28" height="27">
                    <span class="-text-menu">
                        พันธมิตร
                    </span>
                </button>
            </li>
            <li class="nav-item -join-promotion ">
                <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('cashback','accountModal')">
                    <img class="img-fluid -icon-image" src="../assets/images/cashback.png" alt="icon bonus from promotion return by user" width="28" height="27">
                    <span class="-text-menu">
                        คืนยอดเล่น
                    </span>
                </button>
            </li>
            <li class="nav-item -join-promotion ">
                <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('continue','accountModal')">
                    <img class="img-fluid -icon-image" src="../assets/images/continue.png" alt="icon bonus from promotion return by user" width="28" height="27">
                    <span class="-text-menu">
                        ฝากต่อเนื่อง
                    </span>
                </button>
            </li>
            <li class="nav-item -join-promotion ">
                <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('rewards','accountModal')">
                    <img class="img-fluid -icon-image" src="../assets/images/redeem-rewards.png" alt="icon bonus from promotion return by user" width="28" height="27">
                    <span class="-text-menu">
                        แลกของรางวัล
                    </span>
                </button>
            </li>
            <li class="nav-item -join-promotion ">
                <button type="button" class="nav-link js-close-account-sidebar" @click="gotoPage('history','accountModal')">
                    <img class="img-fluid -icon-image" src="../assets/images/history.png" alt="icon bonus from promotion return by user" width="28" height="27">
                    <span class="-text-menu">
                        ประวัติธุรกรรม
                    </span>
                </button>
            </li>
        
        <li class="nav-item js-close-account-sidebar -logout">
            <a href="javascript:void(0)" @click="confirmLogout" class="nav-link js-require-confirm" data-title="ต้องการออกจากระบบ ?">
                <img class="img-fluid -icon-image" src="../assets/images/ez-slot-ic-menu-logout.png" alt="icon logout">
                <div class="-text-menu">
                    ออกจากระบบ
                </div>
            </a>
        </li>
    </ul>
</div>
        <div class="js-profile-account-modal -layout-account">
                    
<div class="x-account-profile -v2">
    <div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">

                    <h3 class="x-title-modal mx-auto text-center ">
    ข้อมูลบัญชี
</h3>
        
        <div class="text-center">
            <div class="my-3">
                


<div class="x-profile-image">
    <img class="img-fluid -profile-image" style="width:100px;max-width: 100px;" :src="getLevelImage2()" alt="customer image">
</div>
            </div>

            <div class="my-3">
                <div class="-text-username">Username:  {{user.code}}</div>
                <a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u>เปลี่ยนรหัสผ่าน</u></a>

                            </div>

            <div class="collapse -change-password-container js-change-password-collapse">
									<div class="js-collapse-content">

									<div class="form-group mt-3">
										<input type="password" v-model="repassword" required="required" placeholder="รหัสผ่านปัจจุบัน" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="repassword1" required="required" placeholder="รหัสผ่านใหม่" class="x-form-control form-control">
									</div>
									<div class="form-group">
										<input type="password" v-model="repassword2" required="required" placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง" class="x-form-control form-control">
									</div>

									<button type="button" @click="changePassword()" class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit">
										<span>ยืนยัน</span>
									</button>

									</div>
						</div>
        </div>

                    <div class="-bank-info-container">
                            <div class="x-customer-bank-info-container -v2">
    <div class="media m-auto">
        <img v-if="user.bank" :src="require('../assets/images/bank/' + user.bank + '.jpg')" class="-img rounded-circle" width="50" height="50" alt="bank-scb">
        <div class="-content-wrapper">
            <span class="-name">{{user.firstname}} {{user.lastname}}</span>
						<span class="-number">{{user.account_no}}</span>
        </div>
    </div>
</div>
                </div>

            
    <div class="x-admin-contact text-center ">
        <span class="x-text-with-link-component">
     <label class="-text-message ">พบปัญหา</label>
     <a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
        <u>ติดต่อฝ่ายบริการลูกค้า</u>
    </a>
</span>
    </div>

            <div class="js-has-info"></div>
            </div>
</div>
            </div>

        </div>
    </div>
</div></div>


		<div class="x-modal modal show" id="accountModalMobile" tabindex="-1" role="dialog" data-loading-container=".modal-body" data-container="#accountModalMobile" aria-modal="true">
		<div class="modal-dialog -modal-size  -modal-mobile -account-modal -no-fixed-button" role="document" style="padding-top: 60px;">
			<div class="modal-content -modal-content" style="height:100vh;">
				<button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
					<i class="fas fa-times"></i>
				</button>
				<div class="modal-header -modal-header">
					<div class="x-modal-mobile-header">
						<div class="-header-mobile-container">
							<h3 class="x-title-modal mx-auto text-center d-inline-block">
								ข้อมูลบัญชี
							</h3>
						</div>
					</div>
				</div>
				<div class="modal-body -modal-body" style="top: 76px;">
					<div class="x-account-profile -v2">
						<div data-animatable="fadeInModal" class="-profile-container animated fadeInModal">
							<div class="text-center">
								<div class="my-3">
									<div class="x-profile-image">
										<img class="img-fluid -profile-image" src="../assets/images/avatar.png" alt="customer image">
									</div>
								</div>

								<div class="my-3">
									<div class="-text-username">Username:  {{user.code}}</div>
									<a href="#0" class="-link-change-password" data-toggle="collapse" data-target=".js-change-password-collapse"><u>เปลี่ยนรหัสผ่าน</u></a>
								</div>

								<div class="-change-password-container js-change-password-collapse collapse" style="">
									<div class="js-collapse-content">

											<div class="form-group mt-3">
												<input type="password" v-model="repassword" required="required" placeholder="รหัสผ่านปัจจุบัน" class="x-form-control form-control">
											</div>
											<div class="form-group">
												<input type="password" v-model="repassword1" required="required" placeholder="รหัสผ่านใหม่" class="x-form-control form-control">
											</div>
											<div class="form-group">
												<input type="password" v-model="repassword2" required="required" placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง" class="x-form-control form-control">
											</div>

											<button type="button" @click="changePassword()" class="btn btn-block -submit">
												<span>ยืนยัน</span>
											</button>
									</div>
								</div>
							</div>

							<div class="-bank-info-container">
								<div class="x-customer-bank-info-container -v2">
									<div class="media m-auto">
										<img v-if="user.bank" :src="require('../assets/images/bank/' + user.bank + '.jpg')" class="-img rounded-circle" width="50" height="50" alt="bank-scb">
										<div class="-content-wrapper">
											<span class="-name">{{user.firstname}} {{user.lastname}}</span>
											<span class="-number">{{user.account_no}}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="x-admin-contact text-center ">
								<span class="x-text-with-link-component">
								<label class="-text-message ">พบปัญหา</label>
								<a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
									<u>ติดต่อฝ่ายบริการลูกค้า</u>
								</a>
								</span>
							</div>

							<div class="js-has-info"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>


		<div
			class="x-modal modal -v2 -with-half-size"
			id="withdrawModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#withdrawModal"
     	 >
<div class="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable -modal-mobile -modal-mobile-clean-padding" role="document">
  <div class="modal-content -modal-content">
    <button
      type="button"
      class="close f-1 "
      data-dismiss="modal"
      aria-label="Close"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-header -modal-header">
      <h3 class="x-title-modal -v2 m-auto">
ถอนเงิน
      </h3>
    </div>
    <div class="modal-body -modal-body" style="top: 0px;">
      <div class="x-withdraw-form -v2">
  <div
    data-animatable="fadeInModal"
    class="-animatable-container animated fadeInModal"
  >
    <div class="text-center d-flex flex-column">
      <div
class="-x-input-icon x-input-operator mb-3 flex-column"
      >
<button
  type="button"
  class="-icon-left -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('minus')"
>
  <i class="fas fa-minus-circle"></i>
</button>
<input
  type="text"
  v-model="withdraw"
  :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
  placeholder="จำนวนเงินที่ต้องการถอน"
  @keypress="isNumber($event)"

/>
						<div class="invalid-feedback " v-if="error">
							<ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
						</div>
<button
  type="button"
  class="-icon-right -btn-icon js-adjust-amount-by-operator"
  @click="setWithdraw('plus')"
>
  <i class="fas fa-plus-circle"></i>
</button>
      </div>
					<!-- <div  v-if="lastbonus.canwithdraw || lastbonus.turncredit">
					<p class="glow" style="font-size:14px;">
						{{lastbonus.canwithdraw}}/{{lastbonus.turncredit}}
					</p>
					</div> -->
      <div
class="x-select-amount js-quick-amount -v2"
data-target-input="#withdraw_amount"
      >
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(100)"
  >
    <span class="-no">100</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(300)"
  >
    <span class="-no">300</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(500)"
  >
    <span class="-no">500</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(1000)"
  >
    <span class="-no">1000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(2000)"
  >
    <span class="-no">2000</span>
  </button>
</div>
<div class="-amount-container">
  <button
    type="button"
    class="btn btn-block -btn-select-amount"
    @click="setWithdraw(5000)"
  >
    <span class="-no">5000</span>
  </button>
</div>
      </div>
    </div>
    <div>- ถอนขั้นต่ำ 100 บาท</div>
    <div class="text-center">
      <button
type="button"
class="btn -submit btn-primary my-0 my-lg-3 f-5 f-lg-6" v-if="!clicked"
						@click="withdrawConfirm()"
      >
{{this.canwithdraw}}
      </button>
    </div>
  </div>

  <input
    type="hidden"
    id="withdraw__token"
    name="withdraw[_token]"
    value="bllExR5-OWRJU6oF0VySYE94ynEFuTfZGWIxep2iqUo"
  />
      </div>
    </div>
  </div>
</div>
      	</div>

		<div
			class="x-modal modal -v2 -with-backdrop -with-separator -with-half-size"
			id="depositModal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-loading-container=".modal-body"
			data-container="#depositModal"
      >
<div class="modal-dialog -modal-size modal-dialog-centered -modal-deposit -modal-mobile mobile-dialog2"  role="document">
    <div class="modal-content -modal-content" style="min-height: 100%;">
      <button
		type="button"
		class="close f-1 "
		data-dismiss="modal"
		aria-label="Close"
      >
<i class="fas fa-times"></i>
      </button>
      <div class="modal-body -modal-body" style="top: 0px;">
<div class="x-pending -v2 ">
  <div
    class="js-content text-center -animated-wrapper animated fadeInModal"
    data-animatable="fadeInModal"
  >
    <div class="-fake-bg-top-wrapper">
      <h3
class="x-title-modal -v2 mx-auto text-center d-inline-block" style="margin-top: 24px;"
      >
ฝากเงิน
      </h3>
    </div>
    <div class="">
      <div class="x-modal-separator-container ">
<div class="-top" v-if="paybridgeMatch">
  <div class="mt-3 -spacer" style="padding: 20px 15px;">
    <div class="paybridge-panel">
      <div class="paybridge-panel-header">
        <span class="paybridge-badge"><span class="paybridge-mark"></span>PayBridge</span>
        <h3>{{ paybridgeAcknowledged ? 'บัญชีโอนเงินของรายการนี้' : 'อ่านก่อนรับบัญชีโอนเงิน' }}</h3>
        <p>{{ paybridgeAcknowledged ? 'โอนยอดตามนี้ แล้วแนบสลิปเพื่อให้ระบบตรวจอัตโนมัติ' : 'ทำตาม 3 ข้อนี้เพื่อให้เครดิตเข้าถูกต้อง' }}</p>
        <div class="paybridge-route">
          <span>{{ paybridgeAcknowledged ? 'Matched' : 'Lock' }}</span>
          <span>{{ paybridgeAcknowledged ? 'Held' : 'Match' }}</span>
          <span>{{ paybridgeAcknowledged ? 'Ready' : 'Verify' }}</span>
        </div>
      </div>
      <div class="paybridge-agreement-card" v-if="!paybridgeAcknowledged">
        <div class="paybridge-agreement-list">
          <div class="paybridge-agreement-item -one">
            <strong>1</strong>
            <span><b>บัญชีใช้ได้ครั้งเดียว</b><small>ห้ามบันทึกหรือโอนซ้ำ</small></span>
          </div>
          <div class="paybridge-agreement-item -two">
            <strong>2</strong>
            <span><b>โอนยอดให้ตรง</b><small>ห้ามโอนขาดหรือเกิน</small></span>
          </div>
          <div class="paybridge-agreement-item -three">
            <strong>3</strong>
            <span><b>ต้องอัปโหลดสลิป</b><small>ไม่แนบสลิป เครดิตไม่เข้า</small></span>
          </div>
        </div>
        <div class="paybridge-agreement-final">
          หากโอนผิดยอด ใช้บัญชีซ้ำ หรือไม่แนบสลิป ระบบไม่สามารถรับผิดชอบได้
        </div>
        <button type="button" class="paybridge-ack-button" @click="acknowledgePayBridgeTerms()">
          <i class="fas fa-check-circle"></i>
          รับทราบและแสดงบัญชีโอนเงิน
        </button>
        <button type="button" class="paybridge-cancel-button" @click="cancelPayBridgeDeposit()">
          ยกเลิกรายการนี้
        </button>
      </div>
      <template v-else>
        <div class="paybridge-amount-card">
          <div>
            <span>ยอดที่ต้องโอน</span>
            <strong>
              {{ Number(deposit_value || 0).toLocaleString('th-TH') }} บาท
              <button type="button" class="paybridge-icon-copy" v-clipboard:copy="String(Number(deposit_value || 0))" v-clipboard:success="clipboardSuccessHandler" aria-label="คัดลอกยอดโอน">
                <i class="fas fa-copy"></i>
              </button>
            </strong>
          </div>
          <div class="paybridge-timer">{{ paybridgeTaskRemainingText || '5:00' }}</div>
        </div>
        <div class="paybridge-account-card">
          <div class="paybridge-bank-mark">
            <img :src="getBankImage((paybridgeMatch.recipientAccount || {}).bankCode)" alt="paybridge bank">
          </div>
          <div class="paybridge-account-detail">
            <span class="paybridge-bank-name">{{ (paybridgeMatch.recipientAccount || {}).bankName || (paybridgeMatch.recipientAccount || {}).bankCode || 'ธนาคาร' }}</span>
            <strong class="paybridge-account-name">{{ (paybridgeMatch.recipientAccount || {}).accountName }}</strong>
            <div class="paybridge-account-number">
              {{ (paybridgeMatch.recipientAccount || {}).accountNo }}
              <button type="button" class="paybridge-icon-copy" v-clipboard:copy="((paybridgeMatch.recipientAccount || {}).accountNo || '').toString().replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler" aria-label="คัดลอกเลขบัญชี">
                <i class="fas fa-copy"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="paybridge-critical-warning">
          <div class="paybridge-warning-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="paybridge-warning-copy">
            <span>บัญชีนี้ใช้ได้เฉพาะรายการนี้เท่านั้น หากโอนไปบัญชีเดิมซ้ำ ทางเว็บจะไม่รับผิดชอบใดๆ</span>
          </div>
        </div>
        <input class="paybridge-file-input" type="file" ref="fileInputPayBridge" accept="image/*" @change="uploadPayBridgeSlip">
        <button type="button" @click="openBrowsePayBridgeFile()" class="paybridge-upload-button">
          <i class="fas fa-cloud-upload-alt mr-2"></i>
          <span>อัปโหลดสลิป PayBridge</span>
        </button>
        <button type="button" @click="cancelPayBridgeDeposit()" class="paybridge-cancel-button -after-account">
          ยกเลิกรายการนี้
        </button>
      </template>
    </div>
  </div>
</div>
<div class="-top " v-else-if="!corepaypage">
  <div class="mt-3 -spacer" v-if="shouldShowDepositGatewayChoice()">
		<div class="x-deposit-bank-info-container -v2">
		<div class="media m-auto" @click="showCorepayPage()">
			<img
			src="https://play-lh.googleusercontent.com/UIdkgBTFEFYTbE-_hUnekG5Aq16au9J7C6RI5gnoAeEZV2zMC3XgOnjL-0aYdmyWk6k=w240-h480-rw"
			class="-img rounded-circle"
			width="50"
			height="50"
			alt="bank-bay"
			/>
			<div class="-content-wrapper">
				<span class="-name" style="font-size: large;">{{ autopeer ? 'ฝากเงินผ่าน AUTOPEER' : (payonex ? 'ฝากผ่าน PayOnex' : (paybridge && isPayBridgeAllowedUser() ? 'ฝากผ่าน PayBridge' : 'แจ้งฝากพร้อมเพย์')) }}</span>
			</div>
			<div class="-copy-wrapper">
			<a
				href="javascript:void(0);"
				class="btn -btn js-copy-to-clipboard"
				style="padding: 10px;"
				>Click</a
			>
			</div>
		</div>
		</div>
	</div>
  <div class="mt-3 -spacer" v-if="bank && bank.scb && user && user.bank !== 'truewallet' && config.scb && shouldUseStandardDepositBanks()">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
        <img
          src="../assets/images/bank/scb.jpg"
          class="-img rounded-circle"
          width="50"
          height="50"
          alt="bank-bay"
        />
        <div class="-content-wrapper">
          <span class="-own-name"
            >{{bank.scb.firstname}} {{bank.scb.lastname}}</span
          >
          <span class="-name">ธนาคารไทยพาณิชย์</span>
          <span id="depositBankNumber" class="-number"
            >{{bank.scb.accountno}}</span
          >
          
        </div>
        <div class="-copy-wrapper">
          <a
            href="javascript:void(0);"
            class="btn -btn js-copy-to-clipboard"
            v-clipboard:copy="bank.scb.accountno.replace(/-/g,'')"
            v-clipboard:success="clipboardSuccessHandler"
            >คัดลอก</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3 -spacer" v-if="bank && bank.ttb && user && user.bank !== 'truewallet' && config.ttb && shouldUseStandardDepositBanks()">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
        <img
          src="../assets/images/bank/ttb.jpg"
          class="-img rounded-circle"
          width="50"
          height="50"
          alt="bank-bay"
        />
        <div class="-content-wrapper">
          <span class="-own-name"
            >{{bank.ttb.firstname}} {{bank.ttb.lastname}}</span
          >
          <span class="-name">ธนาคารทหารไทยธนชาต</span>
          <span id="depositBankNumber" class="-number"
            >{{bank.ttb.accountno}}</span
          >
          
        </div>
        <div class="-copy-wrapper">
          <a
            href="javascript:void(0);"
            class="btn -btn js-copy-to-clipboard"
            v-clipboard:copy="bank.ttb.accountno.replace(/-/g,'')"
            v-clipboard:success="clipboardSuccessHandler"
            >คัดลอก</a
          >
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3 -spacer" v-if="bank.kbank && bank.kbank.accountno && user && user.bank !== 'truewallet' && user.bank !== 'kbank' && config.kbank && shouldUseStandardDepositBanks()">
				<div class="x-deposit-bank-info-container -v2">
				<div class="media m-auto">
					<img
					src="../assets/images/bank/kbank.jpg"
					class="-img rounded-circle"
					width="50"
					height="50"
					alt="bank-bay"
					/>
					<div class="-content-wrapper">
					<span class="-name">ธนาคารกสิกร</span>
					<span class="-own-name"
						>{{bank.kbank.firstname}} {{bank.kbank.lastname}}</span
					>
					<span id="depositBankNumber" class="-number"
						>{{bank.kbank.accountno}}</span
					>
					</div>
					<div class="-copy-wrapper">
					<a
						href="javascript:void(0);"
						class="btn -btn js-copy-to-clipboard"
						v-clipboard:copy="bank.kbank.accountno.toString().replace(/-/g,'')"
														v-clipboard:success="clipboardSuccessHandler"
						>คัดลอก</a
					>
					</div>
				</div>
				</div>
	</div>
	<div class="mt-3 -spacer" v-if="bank && bank.gsb && bank.gsb.accountno && user && user.bank !== 'truewallet' && config.gsb && shouldUseStandardDepositBanks()">
		<div class="x-deposit-bank-info-container -v2">
			<div class="media m-auto">
				<img
					src="../assets/images/bank/gsb.jpg"
					class="-img rounded-circle"
					width="50"
					height="50"
					alt="bank-gsb"
				/>
				<div class="-content-wrapper">
					<span class="-name">ธนาคารออมสิน</span>
					<span class="-own-name">{{bank.gsb.firstname}} {{bank.gsb.lastname}}</span>
					<span id="depositBankNumber" class="-number">{{bank.gsb.accountno}}</span>
				</div>
				<div class="-copy-wrapper">
					<a
						href="javascript:void(0);"
						class="btn -btn js-copy-to-clipboard"
						v-clipboard:copy="bank.gsb.accountno.toString().replace(/-/g,'')"
						v-clipboard:success="clipboardSuccessHandler"
					>คัดลอก</a>
				</div>
			</div>
		</div>
	</div>
	<div class="mt-3 -spacer" v-if="bank && bank.truewallet && user && user.bank == 'truewallet' && config.truewallet">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
        <img
          src="../assets/images/bank/tmw.png"
          class="-img rounded-circle"
          width="50"
          height="50"
          alt="bank-bay"
        />
        <div class="-content-wrapper">
          <span class="-own-name"
            >{{bank.truewallet.firstname}}  {{bank.truewallet.lastname}}</span
          >
          <span class="-name">ทรูมันนี่ วอลเล็ท</span>
          
          
          <span id="depositBankNumber2" class="-number"
            >{{bank.truewallet.mobile}}</span
          >
        </div>
        <div class="-copy-wrapper">
          <a
            href="javascript:void(0);"
          v-clipboard:copy="bank.truewallet.mobile.replace(/-/g,'')"
          v-clipboard:success="clipboardSuccessHandler"
            class="btn -btn js-copy-to-clipboard"
            >คัดลอก</a
          >
        </div>
      </div>
    </div>
  </div>
  <template v-if="shouldUseSlipReadingBanks()">
  <div class="mt-3 -spacer" v-for="(cb, idx) in customBanksList" :key="'cb-'+idx">
    <div class="x-deposit-bank-info-container -v2">
      <div class="media m-auto">
        <img :src="getBankImage(cb.bankCode)" class="-img rounded-circle" width="50" height="50" alt="bank" />
        <div class="-content-wrapper">
          <span class="-name">{{getBankDisplayName(cb.bankCode)}}</span>
          <span class="-own-name">{{cb.firstname}} {{cb.lastname}}</span>
          <span class="-number">{{cb.accountno}}</span>
        </div>
        <div class="-copy-wrapper">
          <a href="javascript:void(0);" class="btn -btn js-copy-to-clipboard" v-clipboard:copy="(cb.accountno || '').toString().replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler">คัดลอก</a>
        </div>
      </div>
    </div>
  </div>
  <div class="-spacer" style="margin-top:8px;">
    <div style="background:linear-gradient(135deg,#ff6b35,#f48d1f);color:#fff;border-radius:8px;padding:10px 14px;text-align:center;font-family:'Kanit',sans-serif;">
      <span style="font-size:14px;font-weight:500;">โอนเสร็จแล้ว กรุณาอัพโหลดสลิปด้านล่างทุกครั้ง</span>
    </div>
  </div>
  </template>
  
  <div class="-spacer">
    <div class="x-danger-zone -v2 ">
    <span
      >กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น</span
    >
    </div>
  </div>
	<div class="-spacer">
		<hr class="-liner">
	</div>
							
  <div class="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right" v-if="promotions && promotions.name">
    <div><p class="-title" style="font-family: 'Kanit', sans-serif; font-size: 12px; padding-bottom:10px;">หากต้องการรับโปร โปรดกดรับโปรทุกครั้งก่อนโอนเงินนะคะ</p></div>
    <div class="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style="transform: translate(0px, 0px);">
      <div :class="{'-promotion-box-wrapper':true,'-active':this.gotpro}" @click="receivePromotion()">
        <button type="button" :class="{'btn -promotion-box-apply-btn js-promotion-apply':true,'-active':this.gotpro}">
          <img src="../assets/images/ic-gift.png" class="-img" :alt="promotions.name" width="26" height="26">
          <span class="-title" style="font-size: 12px;">{{promotions.name}}</span>
        </button>
        <div class="mid">
          <label class="rocker rocker-small" style="box-sizing: inherit;margin:0;padding:0;">
          <input type="checkbox" v-model="this.gotpro" @click="receivePromotion()">
          <span class="switch-left">รับ</span>
          <span class="switch-right">ไม่รับ</span>
        </label>
        </div>
        <!-- <a href="javascript:void(0)" :class="{'-promotion-box-cancel-btn js-cancel-promotion':true,'-show':this.gotpro}">
          <i class="fas fa-times"></i>
        </a> -->
      </div>
      
      <!-- <div class="-promotion-box-wrapper -active">
        <button type="button" class="btn -promotion-box-apply-btn js-promotion-apply -active" data-url="/promotion/27/apply" data-type="deposit" data-display-slide-mode="true">
          <img src="../assets/images/ic-gift.png" class="-img" alt="รับเพิ่ม 2% ทุกบิลฝาก" width="26" height="26">
          <span class="-title" style="font-size: 12px;">รับเพิ่ม 2% ทุกบิลฝาก</span>
        </button>
        <a href="javascript:void(0)" class="-promotion-box-cancel-btn js-cancel-promotion -show" data-url="/promotion-active/cancel" data-display-slide-mode="true">
          <i class="fas fa-times"></i>
        </a>
      </div>

      <div class="-promotion-box-wrapper -active">
        <button type="button" class="btn -promotion-box-apply-btn js-promotion-apply -active" data-url="/promotion/27/apply" data-type="deposit" data-display-slide-mode="true">
          <img src="../assets/images/ic-gift.png" class="-img" alt="รับเพิ่ม 2% ทุกบิลฝาก" width="26" height="26">
          <span class="-title" style="font-size: 12px;">รับเพิ่ม 2% ทุกบิลฝาก</span>
        </button>
        <a href="javascript:void(0)" class="-promotion-box-cancel-btn js-cancel-promotion -show" data-url="/promotion-active/cancel" data-display-slide-mode="true">
          <i class="fas fa-times"></i>
        </a>
      </div> -->
      </div>
  </div>
  <div><p class="-description" style="font-family: 'Kanit', sans-serif;">ฝาก ไม่รับโบนัส ถอนได้ทันทีไม่มีเงื่อนไข</p></div>
  <div v-if="shouldUseSlipReadingBanks()" class="-spacer slip-upload-picker">
    <input
      class="slip-upload-input"
      type="file"
      accept="image/*"
      :disabled="slipUploadInProgress"
      @change="uploadSlip"
    >
    <div class="x-danger-zone -v2" style="background:#28a745;color:#fff;border:2px solid #1e7e34;">
    <span style="font-size:16px;font-weight:bold;">อัพโหลดสลิปที่นี่</span>
    </div>
  </div>
</div>
<div class="-top autopeer-deposit-view" v-else-if="autopeerDeposit && autopeerDeposit.ref">
  <div class="autopeer-deposit-panel">
    <div class="autopeer-summary">
      <div class="autopeer-kicker">รายการฝากพร้อมเพย์</div>
      <div class="autopeer-title">Autopeer</div>
      <div class="autopeer-amount">฿{{Number(autopeerDeposit.amount || 0).toLocaleString('th-TH')}}</div>
    </div>

    <div :class="{'autopeer-deadline':true,'-expired':autopeerUploadExpired}">
      <i class="fas fa-clock"></i>
      <span v-if="!autopeerUploadExpired">เวลาอัปโหลดสลิปคงเหลือ {{autopeerUploadTimeLeft}} นาที</span>
      <span v-else>รายการนี้หมดเวลาแล้ว กรุณาสร้างรายการฝากใหม่</span>
    </div>
    <button v-if="autopeerUploadExpired" type="button" class="autopeer-new-deposit-btn" @click="clearAutopeerDeposit()">
      สร้างรายการฝากใหม่
    </button>

    <img v-if="autopeerDeposit.promptPayQR" :src="autopeerDeposit.promptPayQR" class="autopeer-qr" alt="Autopeer QR Code">

    <div class="autopeer-detail-card">
      <div class="autopeer-row" v-if="autopeerDeposit.bankName">
        <span class="autopeer-label">ธนาคาร</span>
        <div class="autopeer-bank-value">
          <img v-if="getAutopeerBankLogo()" :src="getAutopeerBankLogo()" class="autopeer-bank-logo" :alt="autopeerDeposit.bankName">
          <strong>{{autopeerDeposit.bankName}}</strong>
        </div>
      </div>
      <div class="autopeer-row" v-if="autopeerDeposit.accountNumber">
        <span class="autopeer-label">เลขบัญชี</span>
        <div class="autopeer-copy-value">
          <strong>{{autopeerDeposit.accountNumber}}</strong>
          <button
            type="button"
            class="autopeer-copy-btn"
            v-clipboard:copy="autopeerDeposit.accountNumber.toString().replace(/-/g,'')"
            v-clipboard:success="clipboardSuccessHandler"
          >
            คัดลอก
          </button>
        </div>
      </div>
      <div class="autopeer-row">
        <span class="autopeer-label">Ref</span>
        <strong class="autopeer-ref">{{autopeerDeposit.ref}}</strong>
      </div>
    </div>

    <div :class="{'autopeer-upload':true,'-disabled':autopeerUploadExpired}" @click="openAutopeerBrowseFile()">
      <input type="file" id="autopeer_file" accept="image/*" @change="uploadSlip">
      <div class="autopeer-upload-icon"><i class="fas fa-upload"></i></div>
      <div>
        <div class="autopeer-upload-title">{{autopeerSlipUploaded ? 'อัปโหลดสลิปใหม่' : 'อัปโหลดสลิปโอนเงิน'}}</div>
        <div class="autopeer-upload-subtitle">เลือกส่งสลิปใหม่ได้เรื่อยๆ จนกว่าเวลารายการจะหมด</div>
      </div>
    </div>

    <div class="autopeer-status" v-if="autopeerSlipUploaded">
      <i class="fas fa-check-circle"></i>
      <span>ส่งสลิปแล้ว หากต้องการสามารถอัปโหลดสลิปใหม่ได้จนกว่าจะหมดเวลา</span>
    </div>
  </div>
</div>
<div class="-top" v-else-if="corepayimage">
  <!-- PaymentMX Bank Display -->
  <template v-if="paymentmx && corepayimage === 'bank'">
    <div class="bank-display-container" style="padding: 20px;">
      <div class="bank-card" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 15px; padding: 25px; color: white; max-width: 400px; margin: 0 auto; box-shadow: 0 10px 30px rgba(0,0,0,0.3);">
        <div class="bank-header" style="display: flex; align-items: center; margin-bottom: 20px;">
          <img :src="getBankImage(paymentmxBank.bank_code)" style="width: 60px; height: 60px; border-radius: 50%; background: white; padding: 5px; object-fit: contain;" alt="Bank Logo"/>
          <div style="margin-left: 15px;">
            <div style="font-size: 18px; font-weight: bold;">{{paymentmxBank.bank_name}}</div>
            <div style="font-size: 14px; opacity: 0.9;">{{paymentmxBank.account_name}}</div>
          </div>
        </div>
        <!-- จำนวนเงิน -->
        <div style="background: rgba(255,255,255,0.2); border-radius: 10px; padding: 15px; margin-bottom: 15px;">
          <div style="font-size: 12px; opacity: 0.8;"><i class="fas fa-money-bill-wave"></i> จำนวนเงินที่ต้องโอน</div>
          <div style="font-size: 28px; font-weight: bold;">{{Number(paymentmxBank.amount).toLocaleString('th-TH', {minimumFractionDigits: 2})}} บาท</div>
          <button class="btn btn-light btn-sm mt-2" v-clipboard:copy="paymentmxBank.amount.toString()" v-clipboard:success="clipboardSuccessHandler">
            <i class="fas fa-copy"></i> คัดลอกจำนวนเงิน
          </button>
        </div>
        <!-- เลขบัญชี -->
        <div style="background: rgba(255,255,255,0.2); border-radius: 10px; padding: 15px;">
          <div style="font-size: 12px; opacity: 0.8;"><i class="fas fa-university"></i> หมายเลขบัญชี</div>
          <div style="font-size: 24px; font-weight: bold; letter-spacing: 2px;">{{paymentmxBank.bank_no}}</div>
          <button class="btn btn-light btn-sm mt-2" v-clipboard:copy="paymentmxBank.bank_no.toString().replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler">
            <i class="fas fa-copy"></i> คัดลอกเลขบัญชี
          </button>
        </div>
      </div>
      <div class="alert alert-warning mt-3" style="text-align: center;">
        <i class="fas fa-exclamation-triangle"></i> โอนเงินตามจำนวนที่แจ้งเท่านั้น! ห้ามโอนซ้ำ
      </div>
    </div>
  </template>
  <!-- Other payment methods -->
  <template v-else>
    <div class="alert alert-warning" style="margin-bottom: 15px; padding: 10px; border-radius: 5px; background-color: #fff3cd; border: 1px solid #ffeaa7; color: #856404; text-align: center;">
      <i class="fas fa-exclamation-triangle" style="margin-right: 8px;"></i>
      <strong>คำเตือน:</strong> QR CODE นี้ชำระได้เพียงครั้งเดียวเท่านั้น ห้ามทำรายการซ้ำ
    </div>
    <div v-if="corepayimage.startsWith && corepayimage.startsWith('data:image')" style="text-align: center; padding: 20px;">
      <img :src="corepayimage" style="max-width: 100%; height: auto; width: 300px; border-radius: 10px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);" alt="QR Code">
    </div>
    <template v-else-if="bungpay && bungpayMode === 'TRANSFER' && corepayimage === 'bank'">
      <div class="bank-display-container">
        <div class="bank-card">
          <div class="bank-image-wrapper">
            <img v-if="bungpayBank.bankName" :src="getBankImageFromCode(bungpayBank.bankName)" class="bank-image" alt="Bank Logo"/>
          </div>
          <div class="account-info">
            <div class="amount-section">
              <div class="amount-label"><i class="fas fa-money-bill-wave"></i><span>จำนวนเงินที่ต้องโอน</span></div>
              <div class="amount-value" v-clipboard:copy="String(bungpayBank.depositAmount)" v-clipboard:success="clipboardSuccessHandler" title="คลิกเพื่อคัดลอก">{{ Number(bungpayBank.depositAmount).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} บาท</div>
              <button class="copy-button copy-amount-button" v-clipboard:copy="String(bungpayBank.depositAmount)" v-clipboard:success="clipboardSuccessHandler"><i class="fas fa-copy"></i> คัดลอกจำนวนเงิน</button>
              <div class="amount-warning"><i class="fas fa-exclamation-triangle"></i><span>สำคัญ กรุณาโอนตามจำนวนให้มี.ทศนิยมด้วย เพื่อให้ระบบตรวจสอบอัตโนมัติได้รวดเร็ว</span></div>
            </div>
            <div class="account-name-section">
              <div class="account-label"><i class="fas fa-user"></i><span>ชื่อบัญชี</span></div>
              <div class="account-name">{{ bungpayBank.bankAccountName }}</div>
            </div>
            <div class="account-label"><i class="fas fa-university"></i><span>หมายเลขบัญชี</span></div>
            <div class="account-number" v-clipboard:copy="(bungpayBank.bankAccountNumber || '').replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler" title="คลิกเพื่อคัดลอก">{{ bungpayBank.bankAccountNumber }}</div>
            <button class="copy-button" v-clipboard:copy="(bungpayBank.bankAccountNumber || '').replace(/-/g,'')" v-clipboard:success="clipboardSuccessHandler"><i class="fas fa-copy"></i> คัดลอกเลขบัญชี</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="hengpay || bitpay || bungpay">
      <img :src='"data:image/jpeg;base64,"+corepayimage' class="qr-display-image"/>
    </template>
    <template v-else-if="richpay">
      <div style="width:100%;height:auto;display:flex;justify-content:center;align-items:center;">
        <iframe :src="corepayimage" width="100%" height="100%" style="aspect-ratio: 1/1; max-width:350px; min-width:200px; border:none; display:block;"></iframe>
      </div>
    </template>
    <template v-else>
      <iframe :src="corepayimage" width="100%" style="height:90vh;"></iframe>
    </template>
  </template>
</div>
<div class="-top" v-else-if="corepaymessage">
	{{corepaymessage}}
</div>
<div class="-top" style="padding-bottom: 30px;" v-else-if="corepaypage">
  <div v-if="bank && bank.paymentContent" class="text-center" style="padding: 10px; margin-bottom: 10px;">
    <p style="font-family: 'Kanit', sans-serif; white-space: pre-line; font-size: 14px; color: #333;">{{ bank.paymentContent }}</p>
  </div>
  <div class="x-deposit-bank-info-container -v2" style="background-color: transparent;">
		<div class="media m-auto">
        <div
          data-animatable="fadeInModal"
          class="-animatable-container animated fadeInModal" style="width:80%"
        >
          <div class="text-center d-flex flex-column" style="bottom: 30px;">
          <div
            class="-x-input-icon x-input-operator mb-3 flex-column"
          >
        <button
        type="button"
        class="-icon-left -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('minus')"
        >
        <i class="fas fa-minus-circle"></i>
        </button>
        <input
        type="text"
        v-model="deposit_value"
        :class="{'x-form-control':true,'text-center':true, 'js-withdraw-input-amount':true ,'-no':true,'form-control':true,'is-invalid':(error)?true:false}"
        placeholder="จำนวนเงินที่ต้องการฝาก"
        @keypress="isNumber($event)"

        />
                    <div class="invalid-feedback " v-if="error">
                      <ul class="list-unstyled mb-0"><li>{{error}}</li></ul>
                    </div>
        <button
        type="button"
        class="-icon-right -btn-icon js-adjust-amount-by-operator"
        @click="setWithdraw2('plus')"
        >
        <i class="fas fa-plus-circle"></i>
        </button>
          </div>
                  <!-- <div  v-if="lastbonus.canwithdraw || lastbonus.turncredit">
                  <p class="glow" style="font-size:14px;">
                    {{lastbonus.canwithdraw}}/{{lastbonus.turncredit}}
                  </p>
                  </div> -->
          <div
        class="x-select-amount js-quick-amount -v2"
        data-target-input="#withdraw_amount"
          >
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(100)"
        >
          <span class="-no">100</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(300)"
        >
          <span class="-no">300</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(500)"
        >
          <span class="-no">500</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(1000)"
        >
          <span class="-no">1000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(2000)"
        >
          <span class="-no">2000</span>
        </button>
        </div>
        <div class="-amount-container">
        <button
          type="button"
          class="btn btn-block -btn-select-amount"
          @click="setWithdraw2(5000)"
        >
          <span class="-no">5000</span>
        </button>
        </div>
          </div>
          <div v-if="autopeer" class="autopeer-minimum-note">
            <i class="fas fa-exclamation-circle"></i>
            <span>ฝากขั้นต่ำ 100 บาท กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น!</span>
          </div>
          </div>
        </div>
		</div>
	</div>
</div>
<div class="-bottom">
  <div class="my-3 -spacer" v-if="paybridgeMatch || !corepaypage || corepayimage || (autopeerDeposit && autopeerDeposit.ref)">
    <button
      type="button"
      class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
      data-dismiss="modal"
      aria-label="Close"
    >
      ปิดหน้าต่าง
    </button>
  </div>
  <div class="my-3 -spacer" v-else>
    <button
      type="button"
      class="btn -submit btn-primary text-center m-auto js-user-confirm-deposit"
      @click="genQrCodeCorePay()"
      :disabled="isProcessing || loading"
      :class="{ 'disabled': isProcessing || loading }"
    >
      <span v-if="isProcessing || loading">
        <i class="fas fa-spinner fa-spin"></i> กำลังสร้าง QR Code...
      </span>
      <span v-else>
        ยืนยันการฝาก
      </span>
    </button>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
      </div>
    </div>
</div>
    </div>

<!-- Promotion -->
		  <div data-loading-container=".modal-body" data-container=".promotion-detail-modal-27" data-ajax-modal-always-reload="true" tabindex="-1" class="modal x-modal -promotion-detail-modal promotion-detail-modal-27 show" aria-modal="true" :style="`display: ${(promotion && promotion.name)?`block`:'none'}; padding-right: 8px;`"><div class="modal-dialog -modal-size  " role="document" style="padding-top: 152.8px;">
    <div class="modal-content -modal-content" :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="closePromotion()">
                <i class="fas fa-times"></i>
            </button>
                                <div class="modal-body -modal-body" style="top: 0px;">
                            
        <div class="container">
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="x-page-title-component ">
    <div class="-inner-wrapper">
        <h1 class="-title">โปรโมชั่น</h1>
            </div>
</div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
                            <div class="-real-content">
    <div class="x-card card -card-promotion-detail ">
                                            
            <div class="card-body">
                <div class="-img-container">
                    <img :src="promotion.image" :alt="promotion.name" class="-img-promotion img-fluid">
                </div>
                <div class="x-promotion-content"><h2>{{promotion.name}}</h2>
<p><br>
<div v-html="nl2br(promotion.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;">
</div>
<br>
<!-- <a href="/term-and-condition">เงื่อนไขและกติกาพื้นฐานจะถูกนำมาใช้กับโปรโมชั่นนี้</a> -->
</p></div>
            </div>
                            <div class="card-footer">
                    <!-- <button class="btn -btn -get-promotion-btn js-promotion-apply " data-toggle="modal" data-target="#depositModal" data-promotion-target="promotion-detail-modal-27" data-type="deposit" data-dismiss="modal" data-url="/promotion/27/apply">
                        <span>รับโปรโมชั่น</span>
                    </button> -->
                </div>
                        </div>
                </div>
            
                                                        
                                    <div class="mx-3 mb-3">
                        <div class="x-admin-contact -no-fixed">
                            <span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
     <label class="-text-message ">ติดปัญหา&nbsp;</label>&nbsp;
     <a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
        <u>ติดต่อฝ่ายบริการลูกค้า</u>
    </a>
</span>
                        </div>
                    </div>
                                    </div>
            </div>
    </div>
</div></div>
	</header>
</template>

<script>
import { newPasswordError } from '@/utils/passwordPolicy'
import api from '@/api/config'

import queryString from 'querystring'
import firebase from '@/services/memberData'
import 'firebase/database'
import router from './../router'
import moment from 'moment'
import { getEligibleCustomBanks } from '@/utils/customBankRules'
import { withdrawalErrorMessage, isDefiniteWithdrawalRejection, readWithdrawalAttempt, rememberWithdrawalAttempt, clearWithdrawalAttempt } from '@/utils/withdrawalError'
const audio = new Audio(require('../assets/money.mp3'))
const audio2 = new Audio(require('../assets/moneyout.mp3'))
const axios = require('axios').default
const qs = require('qs')
const PAYBRIDGE_FRONTEND_ENABLED = true
const MIN_DEPOSIT_AMOUNT = 100
export default {
  name: "Header",
  props: {
   mainMenu: String
  },
  components: {
    resetPasswordModal: () => import('./modal/resetPasswordModal.vue'),
  },
  mounted () {
    if (typeof window !== 'undefined') {
      this.paybridgeTaskTimer = window.setInterval(() => {
        this.paybridgeNow = Date.now()
        this.expirePayBridgeTaskIfNeeded()
      }, 1000)
    }
    this.$store.commit('user/SET_LOADING', true)
    const user = localStorage.getItem('userData')
    let _user;
    if (user) {
        _user = JSON.parse(user)
        if(!_user.lastlogin || _user.lastlogin !== moment().tz('Asia/Bangkok').format('YYYY-MM-DD')){
    		  _user.lastlogin = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
    		  //localStorage.setItem('userData', JSON.stringify(_user))
    	  }
        this.restorePayBridgeTask()
        $('#depositModal').on('hidden.bs.modal',  (e)=> {
          this.corepaypage = false;
          this.corepayimage = '';
          this.isProcessing = false;
          if(this.hasActivePayBridgeTask){
            this.persistPayBridgeTask();
          }else{
            this.paybridgeMatch = null;
            this.paybridgeLocalDepositId = '';
            this.paybridgeMessage = '';
            this.paybridgeAcknowledged = false;
            this.paybridgeUseLocalBank = false;
          }
          if(this.unsubscribe){
            this.unsubscribe()
          }
        });
        $('#depositModal').on('shown.bs.modal',  (e)=> {
          this.loadAutopeerDepositFromStorage();
          if(this.autopeermain) this.fetchAutopeerPendingDeposit();
          this.restorePayBridgeTask();
          if(this.autopeerDeposit && this.autopeerDeposit.ref){
            this.corepaypage = true;
            this.corepayimage = '';
          }else if(this.hasActivePayBridgeTask){
            this.corepaypage = false;
            this.corepayimage = '';
          }
        });
    }
    this.$store.dispatch('user/getGames',{user:_user,search:''}).catch(err => { 
      this.$store.commit('user/SET_LOADING', false)
      console.error(err) 
    }).then(()=>{
      this.$store.commit('user/SET_LOADING', false)
    });
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.addLogin(_user)
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        var uid = user.uid;
        
        // ...
      } else {
        this.$store.dispatch('user/setUser',null).catch(err => { console.error(err) });
        // User is signed out
        // ...
      }
    });
      // const user = localStorage.getItem('userData');
    // if(user){
    // 	  const _user = JSON.parse(user);
    // 	  if(!_user.lastlogin || _user.lastlogin !== moment().tz('Asia/Bangkok').format('YYYY-MM-DD')){
    // 		  _user.lastlogin = moment().tz('Asia/Bangkok').format('YYYY-MM-DD')
    // 		  localStorage.setItem('userData', JSON.stringify(_user))
    // 		  this.addLogin(_user)
    // 	  }
    //   }else{
    // 	// firebase.auth().signOut()
    // 	// localStorage.removeItem('userData')
    // 	// router.replace('/login')
    //   }
  },
  beforeDestroy() {
    if (this.paybridgeTaskTimer) {
      clearInterval(this.paybridgeTaskTimer)
      this.paybridgeTaskTimer = null
    }
    if (this.autopeerDepositTimer) {
      clearInterval(this.autopeerDepositTimer)
      this.autopeerDepositTimer = null
    }
  },
  // destroyed() {
  //   window.removeEventListener("focus", this.reloadBalance, false);
  // },
  async created(){
	  //$("#depositChoosePromotionModal").modal('show')
    const user = localStorage.getItem('userData');
    if(user){
      const _user = JSON.parse(user);
      this.getBankDeposit();
      this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
      //window.addEventListener('focus', this.reloadBalance, false)
      this.reloadBalance()
    }else{
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
      // const { code, prefix, ref } = queryString.parse(window.location.search.replace('?', ''))
      // if (prefix) {
      //   localStorage.setItem('prefix', prefix)
      // }
      // if (ref) {
      //   localStorage.setItem('ref', ref)
      // }
    }
	// 	// firebase.auth().signOut()
	// 	// localStorage.removeItem('userData')
	// 	// router.replace('/login')
	// }
	
    const { code } = queryString.parse(window.location.search.replace('?', ''))
    if (!code) return
    const result = await this.getToken(code)
    if (result && result.access_token) {
      const { data } = await this.getProfile(result.access_token)
      this.checkLineLogin(data)
    }
	
  },
  data() {
    return {
      isProcessing: false,
      clicked:false,
      config:{
        scb:true,
        truewallet:true,
        kbank:true,
        gsb:true,
        ttb:true,
      },
      slipReading:false,
      uploadValue:0,
      slipUploadInProgress:false,
      aha:false,
      corepaymessage:'',
      unsubscribe:null,
      corepayimage:'',
      deposit_value:'',
      corepaypage:false,
      corepay: false,
      autopeer: false,
      autopeermain: false,
      autopeerDeposit: null,
      autopeerDepositId: '',
      autopeerSlipUploaded: false,
      autopeerDepositExpiresAtMs: 0,
      autopeerDepositTimer: null,
      autopeerNow: Date.now(),
      bungpay: false,
      bungpayMode: 'QR',
      bungpayBank: {
        bankAccountNumber: '',
        bankAccountName: '',
        bankName: '',
        bankCode: '',
        depositAmount: 0
      },
      corepaymain:false,
      jibpay: false,
      jibpaymain:false,
      payonex:false,
      payonexmain:false,
      paymentmx: false,
      paymentmxBank:{
        bank_code:'',
        bank_no:'',
        bank_name:'',
        account_name:'',
        amount:0
      },
      paybridge: false,
      paybridgeChecking: false,
      paybridgeMatch: null,
      paybridgeLocalDepositId: '',
      paybridgeMessage: '',
      paybridgeAcknowledged: false,
      paybridgeUseLocalBank: false,
      paybridgeNow: Date.now(),
      paybridgeTaskTimer: null,
      bitpay: false,
      bitpaymain:false,
      hengpay: false,
      richpay: false,
      onepay: false,
      onepaymain:false,
      papaya: false,
      papayamain:false,
      coolpay: false,
      coolpaymain:false,
      registerCheck:false,
      otp: '',
      p1:'password',
      p2:'password',
      repassword:'',
      repassword1:'',
      repassword2:'',
      password:'',
      password1:'',
      password2:'',
      fa_spin:false,
      accountOpen:false,
      withdraw: '',
      error: '',
      copyfield:'',
      canwithdraw:'ยืนยัน',
      bank:{
        scb:{
          firstname:'',
          lastname:'',
          accountno:'',
        },
        truewallet:{
          firstname:'',
          lastname:'',
          mobile:'',
        }
      },
      mobile: '',
      step: 1,
      bankselect: 0,
      firstname: '',
      lastname: '',
      account_no: '',
      userFriendId: '',
      pictureUrl: '',
      userId: '',
      email: '',
      displayName: '',
      login_mobile: '',
      login_password: '',
    }
  },
  watch: {
    // whenever question changes, this function will run
    creditincrese(newQuestion, oldQuestion) {
      if(newQuestion){
        audio.volume = 0.5;
        audio.play();
        this.$store.commit("user/SET_CREDIT_INCREASE", false) 
      }
    },
    creditdecrese(newQuestion, oldQuestion) {
      if(newQuestion){
        audio2.volume = 0.5;
        audio2.play();
        this.$store.commit("user/SET_CREDIT_DECREASE", false) 
      }
    },
    
    alertwithdraw(newalert, oldwithdraw) {
      if(newalert){
        if(Number(this.lastbonus.turncredit) <= Number(this.sites_credit.credit)){
          if(Number(this.lastbonus.canwithdraw) > 0 && Number(this.sites_credit.credit) >= Number(this.lastbonus.canwithdraw)){
            $("#withdrawModal").modal('hide')
            this.$swal({ icon: 'question', title: 'แจ้งถอน', html: `คุณทำเทิร์นครบแล้ว! จะถอนได้ ${this.lastbonus.canwithdraw} บาท<br> กดปุ่มยืนยันการถอนได้เลยค่ะ`,showCancelButton: true,confirmButtonText: 'ยืนยัน'}).then((result) => {
              if(result.isConfirmed){
                this.withdraw = this.sites_credit.credit;
                this.withdrawConfirm();
              }
            });
          }else{
            $("#withdrawModal").modal('hide')
            this.$swal({ icon: 'question', title: 'แจ้งถอน', text: `คุณทำเทิร์นครบแล้ว! กดปุ่มยืนยันการถอนได้เลยค่ะ`,showCancelButton: true,confirmButtonText: 'ยืนยัน'}).then((result) => {
              if(result.isConfirmed){
                this.withdraw = this.sites_credit.credit;
                this.withdrawConfirm();
              }
            });
          }
        }else if(Number(this.sites_credit.credit)>5){
          $("#withdrawModal").modal('hide')
          this.$swal({ icon: 'error', title: 'แจ้งถอน', text: `คุณต้องทำยอด ${this.lastbonus.turncredit} ค่ะ`}).then((result) => {
          });
        }
        this.$store.commit("user/SET_ALERT_WITHDRAWALL", false) 
      }
    }
  },
  computed: {
    sites_credit(){
      return this.$store.state.user.sites_credit;
    },
    user(){
      return this.$store.state.user.user;
    },
    customBanksList(){
      if(!this.user || this.user.bank === 'truewallet') return [];
      return getEligibleCustomBanks(this.bank && this.bank.customBanks, this.user.deposittotal);
    },
    creditincrese(){
      return this.$store.state.user.creditincrese;
    },
    creditdecrese(){
      return this.$store.state.user.creditdecrese;
    },
    lastbonus () {
        return this.$store.state.user.lastbonus;
      },
    alertwithdraw (){
      return this.$store.state.user.alertwithdraw;
    },
    promotions (){
      return this.$store.state.user.promotions;
    },
    gotpro (){
      return this.$store.state.user.gotpro;
    },
    promotion(){
      return this.$store.state.user.promotion;
    },
    loading () {
        return this.$store.state.user.loading
    },
    autopeerUploadTimeLeftMs () {
      if(!this.autopeerDeposit || !this.autopeerDepositExpiresAtMs) return 0;
      return Math.max(0, Number(this.autopeerDepositExpiresAtMs) - Number(this.autopeerNow || Date.now()));
    },
    autopeerUploadTimeLeft () {
      const totalSeconds = Math.ceil(this.autopeerUploadTimeLeftMs / 1000);
      if(totalSeconds <= 0) return 'หมดเวลา';
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    autopeerUploadExpired () {
      return !!(this.autopeerDeposit && this.autopeerDepositExpiresAtMs && this.autopeerUploadTimeLeftMs <= 0);
    },
    hasActivePayBridgeTask() {
      return !!this.paybridgeMatch && !this.isPayBridgeTaskExpired();
    },
    paybridgeTaskRemainingSeconds() {
      if (!this.paybridgeMatch || !this.paybridgeMatch.expiresAt) return 0;
      const expiresAtMs = Date.parse(this.paybridgeMatch.expiresAt);
      if (!expiresAtMs) return 0;
      return Math.max(0, Math.ceil((expiresAtMs - this.paybridgeNow) / 1000));
    },
    paybridgeTaskRemainingText() {
      if (!this.paybridgeTaskRemainingSeconds) return '';
      const minutes = Math.floor(this.paybridgeTaskRemainingSeconds / 60);
      const seconds = this.paybridgeTaskRemainingSeconds % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    getAutopeerBankLogo(){
      const bankName = this.autopeerDeposit && this.autopeerDeposit.bankName ? this.autopeerDeposit.bankName.toString().toLowerCase() : '';
      const banks = [
        { keys:['kbank', 'kasikorn', 'กสิกร'], image: require('../assets/images/bank/kbank.jpg') },
        { keys:['scb', 'ไทยพาณิชย์'], image: require('../assets/images/bank/scb.jpg') },
        { keys:['ktb', 'กรุงไทย'], image: require('../assets/images/bank/ktb.jpg') },
        { keys:['bbl', 'bangkok', 'กรุงเทพ'], image: require('../assets/images/bank/bankokbank.jpg') },
        { keys:['bay', 'krungsri', 'กรุงศรี'], image: require('../assets/images/bank/krungsri.jpg') },
        { keys:['ttb', 'ทหารไทย', 'ธนชาต'], image: require('../assets/images/bank/ttb.jpg') },
        { keys:['gsb', 'ออมสิน'], image: require('../assets/images/bank/gsb.jpg') },
        { keys:['baac', 'ธ.ก.ส', 'เพื่อการเกษตร', 'สหกรณ์การเกษตร'], image: require('../assets/images/bank/baac.jpg') },
        { keys:['uob', 'ยูโอบี'], image: require('../assets/images/bank/uob.jpg') },
        { keys:['cimb', 'ซีไอเอ็มบี'], image: require('../assets/images/bank/cimb.jpg') },
        { keys:['lh', 'แลนด์'], image: require('../assets/images/bank/lh.jpg') },
        { keys:['kkp', 'kiatnakin', 'เกียรตินาคิน'], image: require('../assets/images/bank/kiatnakin.jpg') },
        { keys:['ghb', 'ghbank', 'อาคารสงเคราะห์'], image: require('../assets/images/bank/ghbank.jpg') },
        { keys:['standard', 'สแตนดาร์ด'], image: require('../assets/images/bank/standard.jpg') },
      ];
      const bank = banks.find((item) => item.keys.some((key) => bankName.indexOf(key) >= 0));
      return bank ? bank.image : '';
    },
    isAutopeerDepositBankSupported(){
      if(!this.user || !this.user.bank) return false;
      const bank = String(this.user.bank).trim().toLowerCase();
      const unsupported = ['bbl', 'bankokbank', 'bangkokbank', 'ktb', 'ibank', 'islamic', 'ธนาคารอิสลาม', '066', 'kkp', 'kk', 'kiatnakin', '069', 'bay', 'krungsri'];
      return bank !== 'truewallet' && unsupported.indexOf(bank) < 0;
    },
    getAutopeerStorageKey(){
      const userKey = this.user && (this.user.key || this.user.code);
      return userKey ? `xxmac_autopeer_deposit_${userKey}` : '';
    },
    startAutopeerDepositTimer(){
      if(this.autopeerDepositTimer) clearInterval(this.autopeerDepositTimer);
      this.autopeerNow = Date.now();
      this.autopeerDepositTimer = setInterval(() => {
        this.autopeerNow = Date.now();
      }, 1000);
    },
    clearAutopeerDeposit(){
      const key = this.getAutopeerStorageKey();
      this.autopeerDeposit = null;
      this.autopeerDepositId = '';
      this.autopeerSlipUploaded = false;
      this.autopeerDepositExpiresAtMs = 0;
      if(this.autopeerDepositTimer){
        clearInterval(this.autopeerDepositTimer);
        this.autopeerDepositTimer = null;
      }
      if(key) localStorage.removeItem(key);
      this.corepaypage = true;
    },
    setAutopeerDepositFromResponse(data){
      if(!data || !data.ref) return false;
      const expiresAtMs = Number(data.expiresAtMs || 0);
      if(expiresAtMs && expiresAtMs <= Date.now()){
        this.clearAutopeerDeposit();
        return false;
      }
      this.autopeerDepositId = data.id || '';
      this.autopeerDeposit = {
        ref: data.ref,
        promptPayQR: data.promptPayQR || '',
        accountNumber: data.accountNumber || '',
        bankName: data.bankName || '',
        amount: Number(data.amount || this.deposit_value || 0),
      };
      this.autopeerDepositExpiresAtMs = expiresAtMs;
      this.autopeerSlipUploaded = !!data.slipUploaded;
      if(data.amount) this.deposit_value = data.amount;
      this.corepaypage = true;
      this.corepayimage = '';
      this.startAutopeerDepositTimer();
      this.saveAutopeerDeposit();
      return true;
    },
    saveAutopeerDeposit(){
      const key = this.getAutopeerStorageKey();
      if(!key || !this.autopeerDeposit || !this.autopeerDeposit.ref) return;
      localStorage.setItem(key, JSON.stringify({
        id: this.autopeerDepositId,
        deposit: this.autopeerDeposit,
        expiresAtMs: this.autopeerDepositExpiresAtMs,
        slipUploaded: this.autopeerSlipUploaded,
      }));
    },
    loadAutopeerDepositFromStorage(){
      const key = this.getAutopeerStorageKey();
      if(!key) return false;
      const value = localStorage.getItem(key);
      if(!value) return false;
      try {
        const saved = JSON.parse(value);
        if(!saved || !saved.deposit || !saved.deposit.ref || !saved.expiresAtMs || Number(saved.expiresAtMs) <= Date.now()){
          this.clearAutopeerDeposit();
          return false;
        }
        this.autopeerDepositId = saved.id || '';
        this.autopeerDeposit = saved.deposit;
        this.autopeerDepositExpiresAtMs = Number(saved.expiresAtMs);
        this.autopeerSlipUploaded = !!saved.slipUploaded;
        if(saved.deposit.amount) this.deposit_value = saved.deposit.amount;
        this.corepaypage = true;
        this.startAutopeerDepositTimer();
        return true;
      } catch (error) {
        this.clearAutopeerDeposit();
        return false;
      }
    },
    async getAutopeerAuthHeaders(){
      const authUser = firebase.auth().currentUser;
      if(!authUser) throw new Error('กรุณาเข้าสู่ระบบใหม่');
      const token = await authUser.getIdToken();
      return { Authorization:`Bearer ${token}` };
    },
    async fetchAutopeerPendingDeposit(){
      if(!this.user || !this.user.key || !this.autopeermain) return false;
      try {
        const headers = await this.getAutopeerAuthHeaders();
        const response = await axios.post('https://api.xxmac.win/autopeer/pending', { userkey: this.user.key }, { headers });
        if(response.data && response.data.status && response.data.ref){
          return this.setAutopeerDepositFromResponse(response.data);
        }
        this.clearAutopeerDeposit();
        return false;
      } catch (error) {
        console.error('Unable to restore Autopeer deposit', error);
        return this.loadAutopeerDepositFromStorage();
      }
    },
    async createAutopeerDeposit(){
      const amount = Number(this.deposit_value);
      if(!Number.isFinite(amount) || amount < MIN_DEPOSIT_AMOUNT){
        this.$swal({ icon: 'error', title: 'แจ้งฝาก Autopeer', text: `ฝากขั้นต่ำ ${MIN_DEPOSIT_AMOUNT} บาท` });
        return false;
      }
      this.$store.commit('user/SET_LOADING', true);
      try {
        const headers = await this.getAutopeerAuthHeaders();
        const response = await axios.post('https://api.xxmac.win/autopeer/deposit', {
          userkey: this.user.key,
          amount,
        }, { headers });
        if(response.data && response.data.status && response.data.ref){
          this.setAutopeerDepositFromResponse(response.data);
          return true;
        }
        const message = response.data && response.data.data && response.data.data.message
          ? response.data.data.message
          : 'ไม่สามารถสร้างรายการฝาก Autopeer ได้';
        this.$swal({ icon: 'error', title: 'แจ้งฝาก Autopeer มีปัญหา', text: message });
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message;
        this.$swal({ icon: 'error', title: 'แจ้งฝาก Autopeer มีปัญหา', text: message });
      } finally {
        this.$store.commit('user/SET_LOADING', false);
      }
      return false;
    },
    async genQrCodeCorePay(){
      // ป้องกันการกดซ้ำ
      if(this.isProcessing) {
        this.$swal({ icon: 'warning', title: 'กำลังดำเนินการ', text: `กรุณารอสักครู่ กำลังสร้าง QR Code อยู่...` });
        return;
      }

      const amount = Number(this.deposit_value);
      if(!Number.isFinite(amount) || amount < MIN_DEPOSIT_AMOUNT){
        this.$swal({ icon: 'error', title: 'แจ้งฝาก', text: `ฝากขั้นต่ำ ${MIN_DEPOSIT_AMOUNT} บาท` });
        return;
      }

      this.isProcessing = true;
      if(this.autopeer){
        await this.createAutopeerDeposit();
        this.isProcessing = false;
        return;
      }
      const paybridgeHandled = this.payonex ? false : await this.tryPayBridgeDeposit();
      if(paybridgeHandled){
        this.isProcessing = false;
        return;
      }
      if(this.shouldUsePayBridgeAmountFirst()){
        if(this.bungpay){
          this.createBungPayDeposit();
          return;
        }
        this.showLocalDepositBanksAfterPayBridge();
        return;
      }
      
      if(this.papayamain && this.corepaymain){
        if(this.deposit_value < 300) this.papaya = false; else this.corepay = false;
      }
      if(this.papayamain && this.jibpaymain){
        if(this.deposit_value < 300) this.papaya = false; else this.jibpay = false;
      }
      if(this.papayamain && this.bitpaymain){
        if(this.deposit_value < 300) this.papaya = false; else this.bitpay = false;
      }
      if(this.onepayamain && this.corepaymain){
        if(this.deposit_value < 300) this.onepay = false; else this.corepay = false;
      }
      if(this.onepayamain && this.jibpaymain){
        if(this.deposit_value < 300) this.onepay = false; else this.jibpay = false;
      }
      if(this.onepayamain && this.bitpaymain){
        if(this.deposit_value < 300) this.onepay = false; else this.bitpay = false;
      }
      if(this.hengpay){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('hengpay').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:Number(this.deposit_value),
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('hengpay').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().qrcode && doc.data().status){
              this.corepayimage = doc.data().qrcode;
            }else if(doc.data().qrcode && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().qrcode && doc.data().qrcode.responseMesg)
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: doc.data().qrcode.responseMesg+'\nโปรดติดต่อแอดมิน'}).then((result) => {
              });
              this.unsubscribe()
            }else if(doc.data().successful && doc.data().successful === true){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }
          });
          axios.get(`https://api.xxmac.win/repay/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else
      if(this.bitpay){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('papaya').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:this.deposit_value,
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().bitpay && doc.data().successful){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }else
            if(doc.data().bitpay && doc.data().status){
              this.corepayimage = doc.data().bitpay.payurl;
              this.unsubscribe()
            }else if(doc.data().bitpay && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().bitpay)
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
              });
              this.unsubscribe()
            }
          });
          axios.get(`https://api.xxmac.win/bitpay/createorder/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else
      if(this.coolpay){
        if(this.deposit_value < 100){
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 100 บาท`});
        }else{
          this.$store.commit('user/SET_LOADING', true)
          firebase.firestore().collection('papaya').add({
            userkey:this.user.key,
            code:this.user.code,
            createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            status:false,
            amount:this.deposit_value,
          }).then(async (result)=>{
            this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().papaya && doc.data().status){
              this.corepayimage = doc.data().papaya.invoice_url;
              this.unsubscribe()
            }else if(doc.data().papaya && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().papaya)
              this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
              });
              this.unsubscribe()
            }else if(doc.data().papaya && doc.data().status && doc.data().successful){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }
            });
            axios.get(`https://api.xxmac.win/coolpay/${result.id}`).then((result)=>{
              this.$store.commit('user/SET_LOADING', false)
            }).catch((error) => {
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
            })
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
          })
        }
      }else if(this.onepay){
        if(this.deposit_value < 300){
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 300 บาท`});
        }else{
          this.$store.commit('user/SET_LOADING', true)
          firebase.firestore().collection('papaya').add({
            userkey:this.user.key,
            code:this.user.code,
            createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            status:false,
            amount:this.deposit_value,
          }).then(async (result)=>{
            this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
              if(doc.data().papaya && doc.data().status){
                this.corepayimage = doc.data().papaya.payurl;
                this.unsubscribe()
              }else if(doc.data().papaya && !doc.data().status){
                this.$store.commit('user/SET_LOADING', false)
                this.isProcessing = false;
                if(doc.data().papaya)
                  this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
                });
                this.unsubscribe()
              }else if(doc.data().papaya && doc.data().status){
                this.$store.commit('user/SET_LOADING', false)
                this.isProcessing = false;
                this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
                this.unsubscribe()
                $("#depositModal").modal('hide')
              }
            });
            axios.get(`https://api.xxmac.win/onepay/${result.id}`).then((result)=>{
              this.$store.commit('user/SET_LOADING', false)
            }).catch((error) => {
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
            })
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
          })
        }
      }else if(this.papaya){
        if(this.deposit_value < 300){
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 300 บาท`});
        }else{
          this.$store.commit('user/SET_LOADING', true)
          firebase.firestore().collection('papaya').add({
            userkey:this.user.key,
            code:this.user.code,
            createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            status:false,
            amount:this.deposit_value,
          }).then(async (result)=>{
            this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
              if(doc.data().papaya && doc.data().status){
                this.corepayimage = doc.data().papaya.payurl;
                this.unsubscribe()
              }else if(doc.data().papaya && !doc.data().status){
                this.$store.commit('user/SET_LOADING', false)
                this.isProcessing = false;
                if(doc.data().papaya)
                  this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
                });
                this.unsubscribe()
              }else if(doc.data().papaya && doc.data().status){
                this.$store.commit('user/SET_LOADING', false)
                this.isProcessing = false;
                this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
                this.unsubscribe()
                $("#depositModal").modal('hide')
              }
            });
            axios.get(`https://api.xxmac.win/sonic/${result.id}`).then((result)=>{
              this.$store.commit('user/SET_LOADING', false)
            }).catch((error) => {
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
            })
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
          })
        }
      }else if(this.bungpay){
        this.createBungPayDeposit();
      }else if(this.richpay){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('papaya').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:this.deposit_value,
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().papaya && doc.data().status){
              this.corepayimage = doc.data().papaya.payurl;
              this.unsubscribe()
            }else if(doc.data().papaya && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().papaya)
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
              });
              this.unsubscribe()
            }else if(doc.data().papaya && doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }
          });
          axios.get(`https://api.xxmac.win/richpay/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else if(this.jibpay){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('corepay').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:this.deposit_value,
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('corepay').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().corepay && doc.data().status){
              this.corepayimage = doc.data().corepay.redirect;
              this.unsubscribe()
            }else if(doc.data().corepay && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().corepay)
              this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: doc.data().corepay.message+'\nไม่สามารถฝากซ้ำได้โปรดรอ 5 นาทีแล้วแจ้งฝากใหม่'}).then((result) => {
              });
              this.unsubscribe()
            }else if(doc.data().corepay && doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }
          });
          axios.get(`https://api.xxmac.win/jibpa/repay/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else if(this.aha){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('papaya').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:this.deposit_value,
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().aha && doc.data().successful){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }else
            if(doc.data().aha && doc.data().status){
              this.corepayimage = doc.data().aha.payurl;
              this.unsubscribe()
            }else if(doc.data().aha && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().aha)
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
              });
              this.unsubscribe()
            }
          });
          axios.get(`https://api.xxmac.win/aha/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else if(this.payonex){
        const payonexAmount = Number(this.deposit_value);
        if(!Number.isFinite(payonexAmount) || payonexAmount < 100){
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `จำนวนเงินต้องมากกว่า 100 บาท`}).then((result) => {});
        }else{
          const payonexWindow = this.createPayonexPaymentWindow();
          this.$store.commit('user/SET_LOADING', true)
          firebase.firestore().collection('papaya').add({
            userkey:this.user.key,
            code:this.user.code,
            createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            status:false,
            amount:payonexAmount,
          }).then(async (result)=>{
            axios.get(`https://api.xxmac.win/payonex/${result.id}`).then((payonexResponse)=>{
              this.$store.commit('user/SET_LOADING', false);
              this.isProcessing = false;
              const payonexResult = payonexResponse.data || {};
              if(payonexResult.status && payonexResult.url_image){
                this.openPayonexPaymentPage(payonexResult.url_image, payonexWindow);
              }else if(payonexResult.status && payonexResult.qr_image){
                this.closePayonexPaymentWindow(payonexWindow);
                this.corepayimage = payonexResult.qr_image.startsWith('data:image') ? payonexResult.qr_image : `data:image/png;base64,${payonexResult.qr_image}`;
              }else{
                this.closePayonexPaymentWindow(payonexWindow);
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: payonexResult.message || 'ไม่พบหน้าชำระเงิน โปรดลองใหม่อีกครั้ง' });
              }
            }).catch((error) => {
              this.closePayonexPaymentWindow(payonexWindow);
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้างหน้าชำระเงินได้ กรุณาลองใหม่อีกครั้ง' });
            })
          }).catch((error) => {
            this.closePayonexPaymentWindow(payonexWindow);
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถเริ่มรายการฝากเงินได้ กรุณาลองใหม่อีกครั้ง' });
          })
        }
      }else if(this.paymentmx){
        if(this.deposit_value >= MIN_DEPOSIT_AMOUNT){
          this.$store.commit('user/SET_LOADING', true)
          firebase.firestore().collection('paymentmx').add({
            userkey:this.user.key,
            code:this.user.code,
            createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            status:false,
            qty:this.deposit_value,
          }).then(async (result)=>{
            this.unsubscribe = firebase.firestore().collection('paymentmx').doc(result.id).onSnapshot(async (doc) => {
              if(doc.data().account_bank_code && doc.data().status){
                // BANK_TRANSFER: เก็บข้อมูลธนาคารแทน QR
                this.paymentmxBank = {
                  bank_code: doc.data().account_bank_code,
                  bank_no: doc.data().account_bank_no,
                  bank_name: doc.data().account_bank_name,
                  account_name: doc.data().account_name,
                  amount: doc.data().amount
                };
                this.corepayimage = 'bank';
                this.unsubscribe()
                this.isProcessing = false;
              }else if(doc.data().error && !doc.data().status){
                this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: doc.data().error+'\nโปรดติดต่อ admin'}).then((result) => {
                  this.isProcessing = false;
                });
                this.unsubscribe()
              }
            });
            axios.get(`https://api.xxmac.win/paymentmx/${result.id}`).then((result)=>{
              this.$store.commit('user/SET_LOADING', false)
            })
          })
        }else{
          this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `ฝากขั้นต่ำ ${MIN_DEPOSIT_AMOUNT} บาท`}).then((result) => {});
        }
      }else if(this.deposit_value >= MIN_DEPOSIT_AMOUNT){
        this.$store.commit('user/SET_LOADING', true)
        firebase.firestore().collection('corepay').add({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          status:false,
          amount:this.deposit_value,
        }).then(async (result)=>{
          this.unsubscribe = firebase.firestore().collection('corepay').doc(result.id).onSnapshot(async (doc) => {
            if(doc.data().corepay && doc.data().status){
              this.corepayimage = doc.data().corepay.redirect;
              this.unsubscribe()
            }else if(doc.data().corepay && !doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              if(doc.data().corepay)
              this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: doc.data().corepay.message+'\nไม่สามารถฝากซ้ำได้โปรดรอ 5 นาทีแล้วแจ้งฝากใหม่'}).then((result) => {
              });
              this.unsubscribe()
            }else if(doc.data().corepay && doc.data().status){
              this.$store.commit('user/SET_LOADING', false)
              this.isProcessing = false;
              this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
              this.unsubscribe()
              $("#depositModal").modal('hide')
            }
          });
          axios.get(`https://api.xxmac.win/api/repay/${result.id}`).then((result)=>{
            this.$store.commit('user/SET_LOADING', false)
          }).catch((error) => {
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
          })
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
          this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
        })
      }else{
        this.isProcessing = false;
        this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์', text: `ฝากขั้นต่ำ ${MIN_DEPOSIT_AMOUNT} บาท`});
      }
      this.papaya = this.papayamain
      this.corepay = this.corepaymain
      this.jibpay = this.jibpaymain
      this.bitpay = this.bitpaymain
      this.onepay = this.onepaymain
    },
    showCorepayPage(){
      if(this.corepaypage)
        this.corepaypage = false;
      else
        this.corepaypage = true;
    },
    createPayonexPaymentWindow(){
      const paymentWindow = window.open('', '_blank');
      if(!paymentWindow) return null;

      try {
        paymentWindow.opener = null;
        paymentWindow.document.title = 'กำลังเปิด PayOnex';
        paymentWindow.document.body.textContent = 'กำลังเปิดหน้าชำระเงิน PayOnex...';
        paymentWindow.document.body.style.cssText = 'margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f4f7fb;color:#173665;font-family:sans-serif;font-size:18px;font-weight:700;text-align:center;padding:24px;box-sizing:border-box;';
      } catch (error) {
        // The blank window can still be redirected even if its placeholder cannot be styled.
      }

      return paymentWindow;
    },
    openPayonexPaymentPage(paymentPageUrl, paymentWindow){
      try {
        const parsedUrl = new URL(paymentPageUrl);
        if(parsedUrl.protocol !== 'https:' || parsedUrl.hostname !== 'payment.payonex.asia'){
          throw new Error('Invalid Payonex payment page URL');
        }

        if(paymentWindow && !paymentWindow.closed){
          paymentWindow.location.replace(parsedUrl.toString());
        }else{
          window.location.assign(parsedUrl.toString());
        }

        this.corepaypage = false;
        this.deposit_value = '';
        $('#depositModal').modal('hide');
      } catch (error) {
        this.closePayonexPaymentWindow(paymentWindow);
        this.$swal({ icon: 'error', title: 'หน้าชำระเงินไม่ถูกต้อง', text: 'กรุณาลองทำรายการใหม่อีกครั้ง' });
      }
    },
    closePayonexPaymentWindow(paymentWindow){
      if(paymentWindow && !paymentWindow.closed){
        paymentWindow.close();
      }
    },
    shouldUsePayBridgeAmountFirst(){
      return !!(!this.autopeer && !this.payonex && this.isPayBridgeAllowedUser() && this.user && this.user.bank !== 'truewallet');
    },
    shouldShowDepositGatewayChoice(){
      if(this.paybridgeUseLocalBank) return false;
      return !!((this.autopeer || this.paybridge || this.corepay || this.papaya || this.coolpay || this.onepay || this.jibpay || this.bitpay || this.payonex || this.aha || this.bungpay || this.paymentmx) && this.user && this.user.bank !== 'truewallet');
    },
    prepareDepositModal(){
      if(this.loadAutopeerDepositFromStorage()){
        this.corepayimage = '';
        this.corepaymessage = '';
        this.isProcessing = false;
        this.corepaypage = true;
        return;
      }
      this.restorePayBridgeTask();
      if(this.hasActivePayBridgeTask){
        this.corepayimage = '';
        this.corepaymessage = '';
        this.isProcessing = false;
        this.corepaypage = false;
        return;
      }
      this.corepayimage = '';
      this.corepaymessage = '';
      this.paybridgeMatch = null;
      this.paybridgeLocalDepositId = '';
      this.paybridgeMessage = '';
      this.paybridgeAcknowledged = false;
      this.paybridgeUseLocalBank = false;
      this.isProcessing = false;
      this.corepaypage = this.shouldUsePayBridgeAmountFirst();
    },
    showLocalDepositBanksAfterPayBridge(){
      this.$store.commit('user/SET_LOADING', false);
      this.isProcessing = false;
      this.corepayimage = '';
      this.corepaymessage = '';
      this.paybridgeMatch = null;
      this.paybridgeLocalDepositId = '';
      this.paybridgeMessage = '';
      this.paybridgeAcknowledged = false;
      this.paybridgeUseLocalBank = true;
      this.corepaypage = false;
    },
    createBungPayDeposit(){
      this.$store.commit('user/SET_LOADING', true)
      firebase.firestore().collection('papaya').add({
        userkey:this.user.key,
        code:this.user.code,
        createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
        status:false,
        amount:this.deposit_value,
      }).then(async (result)=>{
        this.unsubscribe = firebase.firestore().collection('papaya').doc(result.id).onSnapshot(async (doc) => {
          if(doc.data().bungpay && doc.data().successful){
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            this.$swal({ icon: 'success', title: 'Success', text: `แจ้งฝากพร้อมเพย์เรียบร้อย`})
            this.unsubscribe()
            $("#depositModal").modal('hide')
          }else
          if(doc.data().bungpay && doc.data().status){
            if(this.bungpayMode === 'TRANSFER'){
              this.bungpayBank = {
                bankAccountNumber: doc.data().bankAccountNumber || '',
                bankAccountName: doc.data().bankAccountName || '',
                bankName: doc.data().bankName || '',
                bankCode: doc.data().bankCode || '',
                depositAmount: doc.data().depositAmount || 0
              };
              this.corepayimage = 'bank';
            } else {
              this.corepayimage = doc.data().bungpay.payurl;
            }
            this.unsubscribe()
            this.isGeneratingQrCode = false;
          }
          else if(doc.data().bungpay && !doc.data().status){
            this.$store.commit('user/SET_LOADING', false)
            this.isProcessing = false;
            if(doc.data().bungpay)
              this.$swal({ icon: 'error', title: 'แจ้งฝากพร้อมเพย์มีปัญหา', text: '\nโปรดติดต่อ admin'}).then((result) => {
            });
            this.unsubscribe()
            this.isGeneratingQrCode = false;
          }
        });
        axios.get(`https://api.xxmac.win/apx2sx/${result.id}`).then((result)=>{
          this.$store.commit('user/SET_LOADING', false)
        }).catch((error) => {
          this.$store.commit('user/SET_LOADING', false)
          this.isProcessing = false;
        })
      }).catch((error) => {
        this.$store.commit('user/SET_LOADING', false)
        this.isProcessing = false;
        this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถสร้าง QR Code ได้ กรุณาลองใหม่อีกครั้ง' });
      })
    },
    resendOTP () {
      this.fa_spin = true
      this.checkPhone()
      setTimeout(() => {
        this.fa_spin = false
      }, 3000)
    },
    async checkOTP () {
      const otp = (await firebase.database().ref(`/otpsms/${this.mobile}/value`).once('value')).val()
      if (!this.otp) {
        this.$swal({ icon: 'error', title: 'OTP!', text: 'โปรดระบุ OTP ที่ได้รับ!!!' })
        return
      }
      if (otp) {
        if (this.otp == otp) {
          this.step = 2
        } else {
          this.$swal({ icon: 'error', title: 'OTP!', text: 'OTP ไม่ถูกต้องโปรดตรวจสอบ OTP ใหม่!!!' })
        }
      } else {
        this.$swal({ icon: 'error', title: 'OTP!', text: `OTP ไม่มีในระบบโปรดติดต่อแอดมิน ${this.lineAt}!!!` })
      }
    },
    mobileFormat () {
      if (this.mobile) {
        return `0XX-XXXX-${this.mobile.toString().slice(-3)}`
      }
    },
    resizeImage(file, maxWidth = 800, maxHeight = 800) {
		return new Promise((resolve, reject) => {
		const objectUrl = URL.createObjectURL(file);
			const img = new Image();
			img.onload = () => {
			URL.revokeObjectURL(objectUrl);
			let width = img.width;
			let height = img.height;

			// คำนวณขนาดใหม่
			if (width > maxWidth || height > maxHeight) {
				if (width / height > maxWidth / maxHeight) {
				height = Math.round((height * maxWidth) / width);
				width = maxWidth;
				} else {
				width = Math.round((width * maxHeight) / height);
				height = maxHeight;
				}
			}

			const canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			const ctx = canvas.getContext('2d');
			if (!ctx) {
				reject(new Error('Cannot create image canvas'));
				return;
			}
			ctx.drawImage(img, 0, 0, width, height);

			const supportedType = ['image/jpeg', 'image/png', 'image/webp'].includes(file.type)
				? file.type
				: 'image/jpeg';
			canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Cannot resize slip image'));
          return;
        }
				resolve(blob);
			}, supportedType, 0.85); // 0.85 คือ quality (jpeg/png/webp)
			};
			img.onerror = () => {
				URL.revokeObjectURL(objectUrl);
				reject(new Error('Unsupported slip image'));
			};
			img.src = objectUrl;
		});
	},
    fileToDataUrl(file){
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async uploadAutopeerSlip(event){
      const imageData = event.target.files[0];
      if(!imageData) return;
      if(this.autopeerUploadExpired){
        this.$swal({ icon: 'error', title: 'แจ้งสลิป Autopeer', text: 'รายการฝากหมดเวลาอัปโหลดสลิปแล้ว กรุณาสร้างรายการฝากใหม่' });
        event.target.value = '';
        return;
      }
      if(this.slipUploadInProgress){
        event.target.value = '';
        return;
      }
      this.slipUploadInProgress = true;
      this.$store.commit('user/SET_LOADING', true);
      try {
        const resizedImage = await this.resizeImage(imageData, 800, 800);
        const imgSlip = await this.fileToDataUrl(resizedImage);
        const headers = await this.getAutopeerAuthHeaders();
        const response = await axios.post('https://api.xxmac.win/autopeer/upload-slip', {
          userkey: this.user.key,
          id: this.autopeerDepositId,
          ref: this.autopeerDeposit.ref,
          imgSlip,
        }, { headers });
        if(response.data && response.data.status){
          this.autopeerSlipUploaded = true;
          this.saveAutopeerDeposit();
          this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: 'ส่งสลิปให้ Autopeer แล้ว สามารถอัปโหลดใหม่ได้จนกว่าจะหมดเวลา' });
        }else{
          const message = response.data && response.data.data && response.data.data.message
            ? response.data.data.message
            : 'ไม่สามารถส่งสลิปได้';
          this.$swal({ icon: 'error', title: 'แจ้งสลิป Autopeer', text: message });
        }
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message;
        this.$swal({ icon: 'error', title: 'แจ้งสลิป Autopeer', text: message });
      } finally {
        this.slipUploadInProgress = false;
        this.$store.commit('user/SET_LOADING', false);
        event.target.value = '';
      }
    },
    async uploadSlip(event){
      if(this.autopeerDepositId && this.autopeerDeposit && this.autopeerDeposit.ref){
        return this.uploadAutopeerSlip(event);
      }
      if(this.paybridgeMatch){
        return this.uploadPayBridgeSlip(event);
      }
		const imageData = event.target.files[0];
      if (!imageData) return;
      if (this.slipUploadInProgress) {
        event.target.value = '';
        return;
      }
      if (!this.shouldUseSlipReadingBanks()) {
        this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `ระบบอัพโหลดสลิปยังไม่พร้อมใช้งาน`});
        event.target.value = '';
        return;
      }
      this.slipUploadInProgress = true;
      this.$store.commit('user/SET_LOADING', true);
      this.uploadValue = 0;
      try {
        const resizedImage = await this.resizeImage(imageData, 800, 800);
        const slipRef = firebase.firestore().collection('slip').doc();
        const imageName = imageData.name || '';
        const imageParts = imageName.split('.');
        const extension = (imageParts.length > 1 ? imageParts[imageParts.length - 1] : (imageData.type || 'image/jpeg').split('/').pop()).toLowerCase();
        const storageRef = firebase.storage().ref(`images/slip/${slipRef.id}.${extension}`);
        const uploadTask = storageRef.put(resizedImage, { contentType: resizedImage.type || imageData.type });
        uploadTask.on(`state_changed`,snapshot=>{
          this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        });
        const uploadSnapshot = await uploadTask;
        const url = await uploadSnapshot.ref.getDownloadURL();

        await slipRef.set({
          userkey:this.user.key,
          code:this.user.code,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          createdAtServer: firebase.firestore.FieldValue.serverTimestamp(),
          status:'กำลังดำเนินการ',
          image:url,
          slipStoragePath:storageRef.fullPath,
          uploadStatus:'uploaded',
          user:{
            code:this.user.code,
            firstname:this.user.firstname,
            lastname:this.user.lastname,
            bank:this.user.bank,
            tel:this.user.tel,
            account_no:this.user.account_no,
            bonus:this.user.bonus,
          },
        });
        this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: `ระบบกำลังตรวจสอบสลิปของท่าน กรุณารอสักครู่`}).then((result) => {
        });
      } catch (error) {
        console.log(error.message || error);
        this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: `อัปโหลดสลิปไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อแอดมิน`}).then((result) => {
        });
      } finally {
        this.slipUploadInProgress = false;
        this.$store.commit('user/SET_LOADING', false);
        event.target.value = '';
      }
		
	},
    openAutopeerBrowseFile(){
      if(this.autopeerUploadExpired){
        this.$swal({ icon: 'error', title: 'แจ้งสลิป Autopeer', text: 'รายการฝากหมดเวลาอัปโหลดสลิปแล้ว กรุณาสร้างรายการฝากใหม่' });
        return;
      }
      const input = document.getElementById('autopeer_file');
      if(input) input.click();
    },
    openBrowsePayBridgeFile(){
      if (this.$refs.fileInputPayBridge) {
        this.$refs.fileInputPayBridge.click();
      }
    },
    acknowledgePayBridgeTerms(){
      this.paybridgeAcknowledged = true;
      this.persistPayBridgeTask();
    },
    getPayBridgeTaskStorageKey(){
      let userKey = this.user && (this.user.key || this.user.code);
      if(!userKey){
        try {
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
          userKey = userData.key || userData.code || 'guest';
        } catch (error) {
          userKey = 'guest';
        }
      }
      return `xxmac_paybridge_task_${userKey}`;
    },
    isPayBridgeTaskExpired(match = this.paybridgeMatch){
      if(!match) return true;
      if(!match.expiresAt) return false;
      const expiresAtMs = Date.parse(match.expiresAt);
      return !!expiresAtMs && expiresAtMs <= this.paybridgeNow;
    },
    persistPayBridgeTask(){
      if(!this.paybridgeMatch || this.isPayBridgeTaskExpired()) return;
      localStorage.setItem(this.getPayBridgeTaskStorageKey(), JSON.stringify({
        match: this.paybridgeMatch,
        localDepositId: this.paybridgeLocalDepositId || '',
        depositValue: this.deposit_value || '',
        acknowledged: !!this.paybridgeAcknowledged,
        savedAt: Date.now(),
      }));
    },
    restorePayBridgeTask(){
      try {
        const raw = localStorage.getItem(this.getPayBridgeTaskStorageKey());
        if(!raw) return false;
        const payload = JSON.parse(raw);
        if(!payload || !payload.match || this.isPayBridgeTaskExpired(payload.match)){
          localStorage.removeItem(this.getPayBridgeTaskStorageKey());
          return false;
        }
        this.paybridgeMatch = payload.match;
        this.paybridgeLocalDepositId = payload.localDepositId || '';
        this.deposit_value = payload.depositValue || this.deposit_value;
        this.paybridgeAcknowledged = !!payload.acknowledged;
        this.paybridgeMessage = '';
        return true;
      } catch (error) {
        localStorage.removeItem(this.getPayBridgeTaskStorageKey());
        return false;
      }
    },
    clearPayBridgeTask(){
      localStorage.removeItem(this.getPayBridgeTaskStorageKey());
      this.paybridgeMatch = null;
      this.paybridgeLocalDepositId = '';
      this.paybridgeMessage = '';
      this.paybridgeAcknowledged = false;
    },
    expirePayBridgeTaskIfNeeded(){
      if(!this.paybridgeMatch || !this.isPayBridgeTaskExpired()) return;
      const wasModalOpen = $('#depositModal').hasClass('show');
      this.clearPayBridgeTask();
      if(wasModalOpen){
        $("#depositModal").modal('hide');
        this.$swal({ icon: 'warning', title: 'PayBridge หมดเวลา', text: 'รายการนี้หมดเวลาแล้ว กรุณาเริ่มฝากใหม่อีกครั้ง' });
      }
    },
    reopenPayBridgeTask(){
      if(!this.restorePayBridgeTask() || this.isPayBridgeTaskExpired()){
        this.clearPayBridgeTask();
        this.$swal({ icon: 'warning', title: 'PayBridge หมดเวลา', text: 'รายการนี้หมดเวลาแล้ว กรุณาเริ่มฝากใหม่อีกครั้ง' });
        return;
      }
      this.corepaypage = false;
      this.corepayimage = '';
      $("#depositModal").modal('show');
    },
    cancelPayBridgeDeposit(){
      this.clearPayBridgeTask();
      this.paybridgeUseLocalBank = false;
      this.corepaypage = true;
    },
    isPayBridgeAllowedUser() {
      return PAYBRIDGE_FRONTEND_ENABLED && !!(this.user && this.user.key);
    },
    getPayBridgeApiBase() {
      return localStorage.getItem('xxmacPayBridgeApiBase') || 'https://api.xxmac.win';
    },
    async tryPayBridgeDeposit(){
      try {
        if(!this.isPayBridgeAllowedUser()) return false;
        if(!this.deposit_value || Number(this.deposit_value) < MIN_DEPOSIT_AMOUNT) return false;
        if(!this.user || this.user.bank === 'truewallet') return false;

        this.paybridgeChecking = true;
        this.paybridgeMatch = null;
        this.paybridgeMessage = '';
        this.paybridgeAcknowledged = false;

        const response = await axios.post(`${this.getPayBridgeApiBase()}/paybridge/deposit/check`, {
          userKey: this.user.key,
          code: this.user.code,
          amount: Number(this.deposit_value),
          customerAccount: {
            bank: this.user.bank,
            account_no: this.user.account_no,
            accountName: `${this.user.firstname || ''} ${this.user.lastname || ''}`.trim(),
          },
        });
        const result = response.data || {};
        this.paybridgeLocalDepositId = result.localDepositId || '';
        if(result.action === 'SHOW_BRIDGE_ACCOUNT' || result.status === 'BRIDGE_MATCHED'){
          this.paybridgeMatch = result;
          this.paybridgeAcknowledged = false;
          this.corepaypage = false;
          this.persistPayBridgeTask();
          return true;
        }
        return false;
      } catch (error) {
        this.paybridgeMessage = '';
        return false;
      } finally {
        this.paybridgeChecking = false;
      }
    },
    async uploadPayBridgeSlip(event){
      const imageData = event.target.files[0];
      if(!imageData || !this.paybridgeMatch){
        if(event && event.target) event.target.value = '';
        return;
      }
      this.$store.commit('user/SET_LOADING', true);
      this.uploadValue = 0;
      try {
        const resizedImage = await this.resizeImage(imageData, 800, 800);
        const match = this.paybridgeMatch;
        const amountMinor = Math.round(Number(this.deposit_value || 0) * 100);
        const recipientAccount = match.recipientAccount || {};
        const slipRef = firebase.firestore().collection('slip').doc();
        const imageName = imageData.name || '';
        const imageParts = imageName.split('.');
        const extension = (imageParts.length > 1 ? imageParts[imageParts.length - 1] : (imageData.type || 'image/jpeg').split('/').pop()).toLowerCase();
        const storagePath = `images/slip/paybridge/${slipRef.id}.${extension}`;
        const storageRef = firebase.storage().ref(storagePath);
        const uploadTask = storageRef.put(resizedImage, { contentType: resizedImage.type || imageData.type });
        uploadTask.on(`state_changed`, snapshot => {
          this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        });
        const uploadSnapshot = await uploadTask;
        const url = await uploadSnapshot.ref.getDownloadURL();

        await slipRef.set({
          userkey:this.user.key,
          code:this.user.code,
          provider:'paybridge',
          paybridge_match_id: match.matchId,
          paybridge_deposit_id: match.depositId || '',
          paybridge_withdrawal_id: match.withdrawalId || '',
          paybridge_local_deposit_id: this.paybridgeLocalDepositId || '',
          paybridge_amount_minor: amountMinor,
          paybridge_amount: amountMinor / 100,
          paybridge_recipient_account: recipientAccount,
          paybridge_slip_storage_path: storagePath,
          createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          createdAtServer: firebase.firestore.FieldValue.serverTimestamp(),
          status:'กำลังดำเนินการ',
          image:url,
          slipStoragePath:storagePath,
          uploadStatus:'uploaded',
          user:{
            code:this.user.code,
            firstname:this.user.firstname,
            lastname:this.user.lastname,
            bank:this.user.bank,
            tel:this.user.tel,
            account_no:this.user.account_no,
            bonus:this.user.bonus,
          },
        });

        await axios.post(`${this.getPayBridgeApiBase()}/paybridge/slip/submit`, {
          matchId: match.matchId,
          slipId: slipRef.id,
          localDepositId: this.paybridgeLocalDepositId || '',
          slipStoragePath: storagePath,
          slipImageUrl: url,
          expectedSender: {
            bankCode: this.user.bank,
            accountNo: this.user.account_no,
            accountName: `${this.user.firstname || ''} ${this.user.lastname || ''}`.trim(),
          },
        }).catch(async (error) => {
          await slipRef.set({
            paybridge_submit_error: error && error.message ? error.message : 'PayBridge submit failed',
            paybridge_submit_error_at: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          }, { merge: true });
        });

        this.$swal({ icon: 'success', title: 'แจ้งสลิปเรียบร้อย', text: 'ระบบ PayBridge กำลังตรวจสอบสลิปและจะเติมเครดิตหลังยืนยันสำเร็จ'});
        this.clearPayBridgeTask();
        $("#depositModal").modal('hide');
      } catch (error) {
        this.$swal({ icon: 'error', title: 'แจ้งสลิป', text: 'ไม่สามารถอัปโหลดสลิป PayBridge ได้ กรุณาลองใหม่'});
      } finally {
        this.$store.commit('user/SET_LOADING', false);
        if(event && event.target) event.target.value = '';
      }
    },
    reloadBalance () {
      this.fa_spin = true;
      this.$store.dispatch('user/refreshCreditAll').finally(res => { 
        this.$store.commit('user/SET_LOADING', false); 
        setTimeout(() => {
          this.fa_spin = false; 
        }, 1000);
      }).catch(err => { console.error(err); this.fa_spin = false; })
    },
    getCredit () {
      if (this.sites_credit && this.sites_credit.credit) return this.numberWithCommas(this.sites_credit.credit)
      return 0.00
    },
    gotoPage(page,modal){
      if(modal)
        $("#"+modal).modal('hide')
      router.replace(page);
    },
    getAccountToShow(customerNumber) {
      const lastDigit = customerNumber % 10; // Get the last digit of the customer number
      if (lastDigit <= 1) return 'scb'; // Last digit 0-1, show account 1
      if (lastDigit <= 3) return 'scb2'; // Last digit 2-3, show account 2
      if (lastDigit <= 5) return 'scb3'; // Last digit 4-5, show account 3
      if (lastDigit <= 7) return 'scb4'; // Last digit 6-7, show account 4
      return 'scb5'; // Last digit 8-9, show account 5
    },
    getAccountToShow2(customerNumber){
      const number = Number(customerNumber);
      if (number % 2 === 0) return 'kbank'; // Even number, show account 1
      else return 'kbank2'; // Odd number, show account 2
    },
    getTrueWalletVersion(accountNumber, walletCount = 4) {
      // ตรวจสอบว่ามีหมายเลขบัญชีหรือไม่
      if (!accountNumber) return null;
      
      // แปลงเป็น string และหาตัวเลขตัวสุดท้าย
      const lastDigit = String(accountNumber).slice(-1);
      
      // กรณีมี 4 wallet
      if (walletCount === 4) {
        if (['0', '1', '2'].includes(lastDigit)) {
          return 'truewallet';
        } else if (['3', '4', '5'].includes(lastDigit)) {
          return 'truewallet2';
        } else if (['6', '7'].includes(lastDigit)) {
          return 'truewallet3';
        } else if (['8', '9'].includes(lastDigit)) {
          return 'truewallet4';
        }
      }
      
      // กรณีมี 3 wallet
      if (walletCount === 3) {
        if (['0', '1', '2'].includes(lastDigit)) {
          return 'truewallet';
        } else if (['3', '4', '5'].includes(lastDigit)) {
          return 'truewallet2';
        } else if (['6', '7', '8', '9'].includes(lastDigit)) {
          return 'truewallet3';
        }
      }
      
      return null; // กรณีไม่ตรงกับเงื่อนไขใดๆ
    },
    async getBankDeposit(delay = 1500){
      if(delay > 0){
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      this.bank = (await api.get('/api/deposit-config/' + this.user.key)).data || {};
      this.config = this.bank.config || {};
			if(this.user){
        if(this.bank.autopeer && this.isAutopeerDepositBankSupported()){
          this.autopeer = true;
          this.autopeermain = true;
          await this.fetchAutopeerPendingDeposit();
        }else{
          this.autopeer = false;
          this.autopeermain = false;
          this.clearAutopeerDeposit();
        }
        if(this.bank.corepay){
          this.corepay = true;
          this.corepaymain = true;
        }else{
          this.corepay = false;
          this.corepaymain = false;
        }
        if(this.bank.jibpay){
          this.jibpay = true;
          this.jibpaymain = true;
        }else{
          this.jibpay = false;
          this.jibpaymain = false;
        }
        if(this.bank.bitpay){
          this.bitpay = true;
          this.bitpaymain = true;
        }else{
          this.bitpay = false;
          this.bitpaymain = false;
        }
        if(this.bank.onepay){
          this.onepay = true;
          this.onepaymain = true;
        }else{
          this.onepay = false;
          this.onepaymain = false;
        }
        if(this.bank.aha){
          this.aha = true;
        }else{
          this.aha = false;
        }
        if(this.bank.bungpay){
          this.bungpay = true;
        }else{
          this.bungpay = false;
        }
        this.bungpayMode = this.bank.bungpayMode || 'QR';
        // if(this.bank.hengpay){
        //   this.hengpay = true;
        // }else{
        //   this.hengpay = false;
        // }
        if(this.bank.papaya){
          this.papaya = true;
          this.papayamain = true;
        }else{
          this.papaya = false;
          this.papayamain = false;
        }
        if(this.bank.richpay){
          this.richpay = true;
        }else{
          this.richpay = false;
        }
        if(this.bank.coolpay){
          this.coolpay = true;
          this.coolpaymain = true;
        }else{
          this.coolpay = false;
          this.coolpaymain = false;
        }
        if(this.bank.payonex){
          this.payonex = true;
          this.payonexmain = true;
        }else{
          this.payonex = false;
          this.payonexmain = false;
        }
        if(this.bank.paymentmx){
          this.paymentmx = true;
        }else{
          this.paymentmx = false;
        }
        this.paybridge = !this.autopeer && this.isPayBridgeAllowedUser();
        let scb = this.getAccountToShow(Number(this.user.account_no));
        if(this.bank[scb] && !this.bank[scb].accountno){
          scb = 'scb';
        }
        let kbank = this.getAccountToShow2(Number(this.user.account_no));
        if(kbank !== 'kbank' && this.bank[kbank] && !this.bank[kbank].accountno){
          kbank = 'kbank';
        }
        if(this.config.truewallet && this.bank.truewallet2 && this.bank.truewallet2.mobile && this.bank.truewallet3 && this.bank.truewallet3.mobile && this.bank.truewallet4 && this.bank.truewallet4.mobile && this.user.bank === 'truewallet'){
          //ตัวสุดท้ายของหมายเลขบัญชีเป็น 0,1,2 ให้เป็น truewallet ตัวสุดท้ายของหมายเลขบัญชีเป็น 3,4,5 เป็น truewallet 2 ตัวสุดท้ายของหมายเลขบัญชีเป็น 6,7 เป็น truewallet 3 ตัวสุดท้ายของหมายเลขบัญชีเป็น 8,9 เป็น truewallet 4
          this.bank.truewallet = this.bank[this.getTrueWalletVersion(this.user.account_no.toString(),4)];
        }else
        if(this.config.truewallet && this.bank.truewallet2 && this.bank.truewallet2.mobile && this.bank.truewallet3 && this.bank.truewallet3.mobile && this.user.bank === 'truewallet'){
          this.bank.truewallet = this.bank[this.getTrueWalletVersion(this.user.account_no.toString(),3)];
        }else
        if(this.config.truewallet && this.bank.truewallet2 && this.bank.truewallet2.mobile && this.user.bank === 'truewallet'){
          this.bank.truewallet = (Number(this.user.account_no) % 2 === 0) ? this.bank.truewallet : this.bank.truewallet2;
        }
				this.bank.scb = this.bank[scb];
        this.bank.kbank = this.bank[kbank];
        this.slipReading = !!this.bank.slipReading;
			}
	  },
    shouldUseSlipReadingBanks(){
      return !!(this.slipReading && this.customBanksList && this.customBanksList.length > 0 && this.user && this.user.bank !== 'truewallet');
    },
    shouldUseStandardDepositBanks(){
      return !this.shouldUseSlipReadingBanks();
    },
	  selectBank(bank){
		  this.bankselect = bank;
	  },
	  register () {
		if (this.bankselect === 0) {
			this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณาเลือกธนาคารค่ะ!!!' })
		} else if (this.account_no.trim() === '') {
			this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกหมายเลขบัญชีค่ะ!!!' })
		} else if (this.firstname.trim() === '') {
			this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกชื่อค่ะ!!!' })
		} else if (this.lastname.trim() === '') {
			this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกนามสกุลค่ะ!!!' })
		} else {
      if(this.registerCheck === false){
            this.registerCheck = true;
        const accountNo = this.account_no.toString().trim()
        this.$store.commit('user/SET_LOADING', true)
        axios({
          method: 'post',
          url: 'https://api.xxmac.win/qusercreate/create',
          data: {
            firstname: this.firstname.toString().trim(),
            lastname: this.lastname.toString().trim(),
            bank: this.bankselect,
            account_no: accountNo,
            tel: this.mobile,
            password: this.password,
            userFriendId: (localStorage.getItem('ref')) ? localStorage.getItem('ref') : '',
            agent: (localStorage.getItem('prefix')) ? localStorage.getItem('prefix') : '',
            userId: this.userId,
            email: this.email,
            displayName: this.displayName,
            pictureUrl: this.pictureUrl
          }
        }).then(async response => {
          this.$store.commit('user/SET_LOADING', false)
          if (!response.data.status) {
            this.registerCheck = false;
            this.$swal({ icon: 'error', title: 'Error!', text: `${response.data.error || 'โปรดติดต่อแอดมินเพื่อแจ้งปัญหาในการสมัคร'} หากมีปัญหาโปรดติดต่อ ${this.lineAt}` })
            return
          }
          this.step = 4
          localStorage.removeItem('userId')
          localStorage.removeItem('faceBook')
          localStorage.removeItem('prefix')
          localStorage.removeItem('ref')
          // if (!response.data.status) {
          // 	this.$swal({ icon: 'error', title: 'Error!', text: `โปรดติดต่อแอดมินที่ ${this.lineAt} เพื่อแจ้งปัญหาในการสมัคร` })
          // } else {
          // 	this.step = 4
          // 	localStorage.removeItem('userId')
          // 	localStorage.removeItem('faceBook')
          // 	localStorage.removeItem('prefix')
          // 	localStorage.removeItem('ref')
          // }
        }).catch(() => {
          this.$store.commit('user/SET_LOADING', false)
          this.registerCheck = false;
          this.$swal({ icon: 'error', title: 'Error!', text: `โปรดติดต่อแอดมินที่ ${this.lineAt} เพื่อแจ้งปัญหาในการสมัคร` })
        })
      }
		}
    },
    checkBankAccount () {
      const accountNo = this.account_no.toString().trim()
      if (this.bankselect === 0 || !accountNo) return
      axios({
        method: 'get',
        url: 'https://api.xxmac.win/api/checkaccount/' + encodeURIComponent(this.bankselect) + '/' + encodeURIComponent(accountNo)
      }).then(async response => {
        if (!response.data.status) {
          this.$swal({ icon: 'error', title: 'Error!', text: `เลขบัญชีนี้ถูกใช้กับธนาคารนี้แล้วค่ะ หากมีปัญหาโปรดติดต่อ ${this.lineAt}` })
          this.account_no = ''
        }
      })
    },
    checkPassword () {
      if (this.password.toString().trim().length < 6) {
        this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัวอักษรค่ะ!!!' })
      } else if (this.password !== this.password2) {
        this.$swal({ icon: 'error', title: 'Error!', text: 'รหัสผ่านไม่ตรงกันค่ะ!!!' })
      } else {
        this.step = 3
      }
    },
	showpassword(p){
		if(p === 'password'){
			this.p1 = 'text';
		}else{
			this.p2 = 'text';
		}
	},
	hidepassword(p){
		if(p === 'password'){
			this.p1 = 'password';
		}else{
			this.p2 = 'password';
		}
	},
    async checkPhone () {
      if (!this.mobile.toString().trim()) {
        this.$swal({ icon: 'error', title: 'Error!', text: 'กรุณากรอกเบอร์โทรศัพท์ค่ะ!!!' })
      } else if (this.mobile.toString().trim().length !== 10) {
        this.$swal({ icon: 'error', title: 'Error!', text: 'เบอร์โทร จำนวนตัวอักษรต้อง 10 ตัวเท่านั้นค่ะ!!!' })
      } else {
        axios({
          method: 'get',
          url: 'https://api.xxmac.win/api/checkmobile/' + this.mobile.trim()
        }).then(async response => {
          if (!response.data.status) {
            this.$swal({ icon: 'error', title: 'Error!', text: `หมายเลขโทรศัพท์นี้เป็นสมาชิกอยู่แล้วค่ะ หากมีปัญหาโปรดติดต่อ ${this.lineAt}` })
          } else {
            const sms = (await firebase.database().ref('/public/sms').once('value')).val()
            if (sms && sms.status) {
              this.step = 1.2
            } else {
              this.step = 2
            }
          }
        })
      }
    },
	isNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
	checkLineLogin (data) {
		if(data.userId && this.user && this.user.key){
	  		/* LINE account linkage requires server verification. */
			this.$swal({ icon: 'success', title: 'Line', text: 'เชื่อมต่อระบบ Line เรียบร้อยแล้วค่ะ' })
			const user = localStorage.getItem('userData');
			if(user){
				const _user = JSON.parse(user);
				this.$store.dispatch('user/setUser',_user).catch(err => { console.error(err) });
			}
		}
    },
	async getToken (code) {
      const data = qs.stringify({
        grant_type: 'authorization_code',
        code,
        redirect_uri: this.callbackUri,
        client_id: this.clientId,
        client_secret: this.clientSecret
      })
      let response
      await axios({
        method: 'post',
        url: 'https://api.line.me/oauth2/v2.1/token',
        data: data
      }).then(async res => {
        if (res.status !== 200) {
          this.error = 'โปรดติดต่อแอดมิน'
        } else if (res.data) {
          response = res.data
        }
      })
      return response
    },
	async getProfile (token) {
      return await axios.get('https://api.line.me/v2/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    },
    async addLogin(user){
      //console.log('addLogin',user);
    if(user && user.key && user.tel){
      await axios.get('https://api.ipify.org?format=json').then(x => {
        if(x.data.ip && user.key){
              axios({
                method: 'post',
                url: 'https://api.xxmac.win/api/addlogin',
                data: {
                  key: user.key,
                  ip: x.data.ip,
                  level1: (user.level1)?user.level1:'',
                }
              })
        }
      });
    }
        // await axios.get('https://checkip.amazonaws.com').then(x => {
        //   if(x){
        //     firebase.database().ref(`/users/${key}`).update({
        //       ip:x
        //     });
        //   }
        // });
	},
	nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
	closePromotion(){
		this.$store.commit('user/SET_PROMOTION', [])
	},
	clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
	getBankImageFromCode(bankName) {
		const bankMap = { 'SCB': 'scb', 'KBANK': 'kbank', 'BBL': 'bankokbank', 'KTB': 'ktb', 'BAY': 'krungsri', 'TTB': 'ttb', 'GSB': 'gsb', 'UOB': 'uob', 'TISCO': 'tisco', 'KKP': 'kiatnakin', 'LHBANK': 'lh', 'IBANK': 'ธนาคารอิสลาม', 'GHB': 'ghbank', 'CIMB': 'cimb', 'BAAC': 'baac', 'ICBC': 'icbc', 'SCBN': 'standard' };
		const fileName = bankMap[bankName] || 'kbank';
		try { return require('@/assets/images/bank/' + fileName + '.jpg'); } catch (e) { try { return require('@/assets/images/bank/' + fileName + '.png'); } catch (e2) { return require('@/assets/images/bank/kbank.jpg'); } }
	},
    getBankImage(bankCode) {
		const key = (bankCode || '').toString().toLowerCase();
		const bankMap = {
			'002': 'bankokbank',
			'004': 'kbank',
			'006': 'ktb',
			'011': 'ttb',
			'014': 'scb',
			'020': 'standard',
			'022': 'cimb',
			'024': 'uob',
			'025': 'krungsri',
			'030': 'gsb',
			'033': 'ghbank',
			'034': 'baac',
			'065': 'thanachart',
			'066': 'ธนาคารอิสลาม',
			'067': 'tisco',
			'069': 'kiatnakin',
			'070': 'icbc',
			'073': 'lh',
			scb: 'scb',
			kbank: 'kbank',
			krungsri: 'krungsri',
			ktb: 'ktb',
			bbl: 'bankokbank',
			bankokbank: 'bankokbank',
			ttb: 'ttb',
			gsb: 'gsb',
			baac: 'baac',
			cimb: 'cimb',
			uob: 'uob',
			kiatnakin: 'kiatnakin',
			ghbank: 'ghbank',
			tisco: 'tisco',
			lh: 'lh',
			lhbank: 'lh',
			bay: 'krungsri',
			ibank: 'ธนาคารอิสลาม',
			scbn: 'standard',
			truewallet: 'tmw'
		};
		const bankName = bankMap[key] || 'kbank';
		try { return require(`@/assets/images/bank/${bankName}.jpg`); } catch (e) {
			try { return require(`@/assets/images/bank/${bankName}.png`); } catch (e2) {
				return require('@/assets/images/bank/kbank.jpg');
			}
		}
	},
    getBankDisplayName(bankCode){
      const key = (bankCode || '').toString().toLowerCase();
      const map = {
        scb:'ธนาคารไทยพาณิชย์',
        kbank:'ธนาคารกสิกรไทย',
        krungsri:'ธนาคารกรุงศรีอยุธยา',
        ktb:'ธนาคารกรุงไทย',
        bbl:'ธนาคารกรุงเทพ',
        bankokbank:'ธนาคารกรุงเทพ',
        ttb:'ธนาคารทหารไทยธนชาต',
        gsb:'ธนาคารออมสิน',
        baac:'ธ.ก.ส.',
        truewallet:'ทรูมันนี่ วอลเล็ท',
        cimb:'ธนาคาร CIMB',
        uob:'ธนาคาร UOB',
        kiatnakin:'ธนาคารเกียรตินาคินภัทร',
        ghbank:'ธนาคารอาคารสงเคราะห์',
        tisco:'ธนาคารทิสโก้',
        lh:'ธนาคารแลนด์ แอนด์ เฮ้าส์',
        lhbank:'ธนาคารแลนด์ แอนด์ เฮ้าส์',
        bay:'ธนาคารกรุงศรีอยุธยา',
        ibank:'ธนาคารอิสลาม',
        scbn:'ธนาคารสแตนดาร์ดชาร์เตอร์ด'
      };
      return map[key] || bankCode;
    },
	gotoMain(){
		router.replace('/')
	},
	receivePromotion(){
		if(this.user && this.user.key){
			if(this.gotpro){
				this.$store.commit("user/SET_GOT_PRO", false);
				firebase.database().ref(`users/${this.user.key}`).update({bonus:'N'});
			}else{
				this.$store.commit("user/SET_GOT_PRO", true);
				firebase.database().ref(`users/${this.user.key}`).update({bonus:'Y'});
			}
		}
	},
	getUserId(){
	  	const user = localStorage.getItem('userData');
		if(user){
			const _user = JSON.parse(user);
			return _user;
		}
	},
	async moveCreditToWallet(){
		this.$store.commit('user/SET_LOADING', true)
		//this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
		const user = this.getUserId();
    this.$store.dispatch('user/refreshCreditAll').finally(res => { 
      this.$store.dispatch('user/getLastBonus', user).finally(res => {
        this.$store.commit('user/SET_LOADING', false)
        if(this.lastbonus.turncredit){
          this.$store.commit("user/SET_ALERT_WITHDRAWALL", true);
        }
      }).catch(err => { console.error(err) })
    }).catch(err => { console.error(err); this.fa_spin = false; })
	},
	async checkPromotions(){
    this.$store.commit('user/SET_LOADING', true)
    try {
      await this.getBankDeposit(0);
    } catch (error) {
      console.error('Unable to refresh deposit configuration', error);
    }
    this.prepareDepositModal();
    this.$store.dispatch('user/checkPromotions').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
	getBank(){
		if(this.user.bank){
			require(`../assets/images/${this.user.bank}.jpg`)
		}
	},
	numberWithCommas (x) {
	  if(!x) x = 0;
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  numberWithCommas2 (x) {
	  if(!x) x = 0;
      return x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

	confirmLogout(){
      this.$swal({ icon: 'question', title: 'Log Out!', text: 'ยืนยันออกจากระบบ',showCancelButton: true,confirmButtonText: 'ตกลง'}).then((result) => {
      if (result.isConfirmed) {
        $("#accountModal").modal('hide')
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        this.$store.dispatch('user/setUser',[]).catch(err => { console.error(err) });
      }
      })
    },
	setWithdraw (value) {
		  if (value === 'plus') {
			  this.withdraw = (this.withdraw) ? this.withdraw + 10 : 10
		  } else if (value === 'minus') {
			  if (this.withdraw) { this.withdraw = (this.withdraw) ? this.withdraw - 10 : 0 }
		  } else if (value > 0) { this.withdraw = value } else { this.withdraw = 0 }
	},
  setWithdraw2 (value) {
		  if (value === 'plus') {
			  this.deposit_value = (this.deposit_value) ? this.deposit_value + 10 : 10
		  } else if (value === 'minus') {
			  if (this.deposit_value) { this.deposit_value = (this.deposit_value) ? this.deposit_value - 10 : 0 }
		  } else if (value > 0) { this.deposit_value = value } else { this.deposit_value = 0 }
	},
	rand () {
    	return Math.random().toString(36).substr(2); // remove `0.`
	},
	token () {
    	return this.rand() + this.rand(); // to make it longer
	},
	async withdrawConfirm() {
    if (this.clicked) return;
    if (!this.config.withdraw) {
      this.$swal({ icon: 'warning', title: 'ข้อความ!', text: 'ระบบถอนเงินปิดปรับปรุงชั่วคราว กรุณาติดต่อเจ้าหน้าที่' });
      return;
    }
    this.clicked = true;
    let user;
    let submitted = false;
    let retrying = false;
    try {
      user = this.getUserId();
      if (!user || !user.key) throw new Error('MEMBER_SESSION_REQUIRED');
      const withdrawAmount = Number(this.withdraw);
      if (!Number.isFinite(withdrawAmount) || withdrawAmount < 100 || Math.abs(Math.round(withdrawAmount * 100) - withdrawAmount * 100) > 0.000001) throw new Error('INVALID_AMOUNT');

      let attempt = readWithdrawalAttempt(user.key);
      retrying = !!attempt;
      if (attempt && attempt.amount !== withdrawAmount) throw new Error('WITHDRAWAL_UNCERTAIN_AMOUNT');
      // Retry an uncertain request with its original ID, even if its debit changed the balance.
      if (!attempt) {
        if (withdrawAmount > Number(this.sites_credit.credit)) throw new Error('INSUFFICIENT_CREDIT');
        const pendingWithdrawals = await firebase.firestore()
          .collection('history')
          .where('userkey', '==', user.key)
          .where('status', '==', 'กำลังดำเนินการ')
          .where('type', '==', 'ถอน')
          .limit(1)
          .get();
        if (!pendingWithdrawals.empty) throw new Error('WITHDRAWAL_ALREADY_PENDING');

        let dailyTotal = 0;
        const completedWithdrawals = await firebase.firestore()
          .collection('history')
          .where('userkey', '==', user.key)
          .where('status', '==', 'ดำเนินการแล้ว')
          .where('type', '==', 'ถอน')
          .where('createdate', '>=', moment().format('YYYY-MM-DD')+' 00:00:00')
          .get();
        completedWithdrawals.forEach(doc => { dailyTotal += Number(doc.data().qty); });
        const limits = { 1: 5000, 2: 20000, 3: 50000, 4: 80000, 5: 100000, 6: 150000, 7: 250000, 8: 500000, 9: 1000000, 10: 1500000, 11: 2000000 };
        const dailyLimit = limits[this.user.level || 1] || limits[1];
        if (dailyTotal + withdrawAmount > dailyLimit) throw new Error('DAILY_WITHDRAWAL_LIMIT');
        attempt = { amount: withdrawAmount, requestId: 'withdraw-' + this.token() };
        rememberWithdrawalAttempt(user.key, attempt);
      }

      submitted = true;
      const response = await axios({
        method: 'post',
        url: 'https://api.xxmac.win/quserwithdraw/userwithdraw',
        timeout: 60000,
        headers: { 'x-idempotency-key': attempt.requestId },
        data: { key: user.key, tel: user.tel, token: attempt.requestId, credit: attempt.amount }
      });
      // HTTP 200 alone is insufficient: the withdrawal must explicitly succeed.
      if (!response.data || response.data.status !== true || response.data.error) {
        const failure = new Error('WITHDRAWAL_RESPONSE_REJECTED');
        failure.response = response;
        throw failure;
      }
      clearWithdrawalAttempt(user.key);
      await this.$swal({ icon: 'success', title: 'ทำรายการถอนสำเร็จ', text: 'กรุณารอเงินเข้าบัญชี ระบบจะดำเนินการโดยเร็วที่สุด' });
      $("#withdrawModal").modal('hide');
      this.reloadBalance();
    } catch (error) {
      if (submitted && user && isDefiniteWithdrawalRejection(error, retrying)) clearWithdrawalAttempt(user.key);
      await this.$swal({ icon: 'error', title: 'ไม่สามารถทำรายการได้', text: withdrawalErrorMessage(error) });
    } finally {
      this.clicked = false;
    }
  },
	showTabAccount() {
      if(!this.accountOpen) this.accountOpen = true; else this.accountOpen = false;
    },
	async changePassword () {
      const errorKey = newPasswordError(this.repassword1)
      if (!this.repassword || !this.repassword2) {
        this.$swal({ icon: 'warning', title: 'Password', text: 'กรุณาระบุข้อมูลให้ครบถ้วน' })
        return
      }
      if (errorKey || this.repassword1 !== this.repassword2) {
        this.$swal({ icon: 'warning', title: 'Password', text: errorKey || 'รหัสผ่านใหม่ไม่ตรงกัน' })
        return
      }
      this.$store.commit('user/SET_LOADING', true)
      let changed = false
      try {
        const account = firebase.auth().currentUser
        if (!account) throw new Error('AUTH_REQUIRED')
        await account.reauthenticateWithCredential(firebase.auth.EmailAuthProvider.credential(account.email, this.repassword))
        await account.getIdToken(true)
        const result = await api.post('/api/resetpassword', { key: this.getUserId().key, password: this.repassword1 })
        if (!result.data || !result.data.status) throw new Error('RESET_FAILED')
        changed = true
        await firebase.auth().signInWithEmailAndPassword(account.email, this.repassword1)
        this.$swal({ icon: 'success', title: 'Password', text: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว' })
        $('#accountModalMobile').modal('hide')
        $('#accountModal').modal('hide')
      } catch (_) {
        if (changed) {
          await firebase.auth().signOut().catch(() => {})
          this.$swal({ icon: 'info', title: 'Password', text: 'เปลี่ยนรหัสผ่านแล้ว กรุณาเข้าสู่ระบบด้วยรหัสใหม่' })
        } else {
          this.$swal({ icon: 'error', title: 'Password', text: 'เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาตรวจรหัสผ่านเดิมหรือเข้าสู่ระบบใหม่' })
        }
      } finally {
        this.repassword = ''
        this.repassword1 = ''
        this.repassword2 = ''
        this.$store.commit('user/SET_LOADING', false)
      }
    },
	login () {
      if (!this.login_mobile) {
        this.$swal({ icon: 'warning', title: 'ข้อความ!', text: 'โปรดระบุเบอร์มือถือค่ะ!!!' })
        $('#login_mobile').focus()
      } else if (!this.login_password) {
        this.$swal({ icon: 'warning', title: 'ข้อความ!', text: 'โปรดระบุ Password ค่ะ!!!' })
        $('#login_password').focus()
      } else {
		this.$store.commit('user/SET_LOADING', true)
        axios({
          method: 'post',
          url: 'https://api.xxmac.win/api/login',
          data: {
            mobile: this.login_mobile,
            password: this.login_password
          }
        }).then(async res => {
		      this.$store.commit('user/SET_LOADING', false)
          if (res.data && !res.data.status) {
            this.$swal({ icon: 'error', title: 'ข้อความ!', text: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!' })
            $('#login_mobile').focus()
          } else {
            firebase.auth().signInWithEmailAndPassword(this.login_mobile.trim().toLowerCase() + '@xxmac.co', this.login_password).then(async (res2) => {
              if (res2.user) {
                localStorage.setItem('userData', JSON.stringify(res.data))
				        this.$store.dispatch('user/setUser',res.data).catch(err => { console.error(err) });
                $("#loginModal").modal('hide')
                this.reloadBalance()
              } else {
				        this.$swal({ icon: 'error', title: 'ข้อความ!', text: 'โปรดติดต่อแอดมินค่ะ!!!' })
              }
            }).catch((err) => {
              this.$swal({ icon: 'error', title: 'ข้อความ!', text: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!' })
            })
          }
        })
      }
    },
    showModal(oldModal,newModal){
      $("#"+oldModal).modal('hide');
      $("#"+newModal).modal('show');
    },
    getLevelImage(){
      if(this.user.level){
        return require(`../assets/images/level/${this.user.level}.png`)
      }else{
        return require('../assets/images/level/1.png')
      }
    },
    getLevelImage2(){
      if(this.user.level){
        return require(`../assets/images/level/${this.user.level}.png`)
      }else{
        return require('../assets/images/level/1.png')
      }
    },
  }
}
</script>
<style scoped>
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
    
    to {
text-shadow: 0 0 5px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a, 0 0 5px #dbc47a;
    }
}
@media (max-width: 500px) { 
	.x-header #headerBrand .navbar-brand .-logo {
		width: 150px;
	}
}
.-balance-container .-user-balance .-inner-box-wrapper2 {
    position: relative;
    margin-right: 5px;
    margin-left: 15px;
    padding: 6px 24px 6px 0px;
    font-weight: 500;
    border-radius: 20px;
    color: #fff;
    text-align: right;
}
.x-logged .-profile-container .-btn-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.2rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}
.x-logged .-profile-container .-btn-mobile-wrapper .-profile-name2 {
	font-family: 'Kanit', sans-serif;
    font-size: 1.1rem;
  /*  color: #e5e5e5; */
    font-weight: 200;
    margin-right: 2px;
    padding-left: 10px;
    color: #f9f9d6;
	text-align: center;
}

.-balance-container .-user-balance .-btn-balance2 {
    position: absolute;
    right: 10px;
    padding: 0;
    color: #FFFFFF;
    background: transparent;
    border: none;
}
.cCsozd {
    display: inline-block;
    padding: 0.5rem 1rem;
    height: 44px;
    font-size: 1em;
    line-height: 1.5;
    border: none;
    border-radius: 0.25rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
}
.ewHin {
    background: rgb(0, 187, 0);
    color: rgb(255, 255, 255);
    height: 50px;
    min-width: 180px;
    border-radius: 25px;
    padding-left: 34px;
    padding-right: 34px;
}
.ewHin .icon {
    height: 18px;
    margin: 0px 0.5rem;
    vertical-align: sub;
    border: 0px;
}



.mid {
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Switch starts here */
.rocker {
  display: inline-block;
  position: relative;
  /*
  SIZE OF SWITCH
  ==============
  All sizes are in em - therefore
  changing the font-size here
  will change the size of the switch.
  See .rocker-small below as example.
  */
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #888;
  width: 7em;
  height: 4em;
  overflow: hidden;
  border-bottom: 0.5em solid #eee;
}

.rocker-small {
  font-size: 0.75em; /* Sizes the switch */
  margin: 1em;
}

.rocker::before {
  content: "";
  position: absolute;
  top: 0.5em;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999;
  border: 0.5em solid #eee;
  border-bottom: 0;
}

.rocker input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-left,
.switch-right {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
  width: 3em;
  transition: 0.2s;
}

.switch-left {
  height: 2.4em;
  width: 2.75em;
  left: 0.85em;
  bottom: 0.4em;
  background-color: #ddd;
  transform: rotate(15deg) skewX(15deg);
}

.switch-right {
  right: 0.5em;
  bottom: 0;
  background-color: #bd5757;
  color: #fff;
}

.switch-left::before,
.switch-right::before {
  content: "";
  position: absolute;
  width: 0.4em;
  height: 2.45em;
  bottom: -0.45em;
  background-color: #ccc;
  transform: skewY(-65deg);
}

.switch-left::before {
  left: -0.4em;
}

.switch-right::before {
  right: -0.375em;
  background-color: transparent;
  transform: skewY(65deg);
}

input:checked + .switch-left {
  background-color: #0084d0;
  color: #fff;
  bottom: 0px;
  left: 0.5em;
  height: 2.5em;
  width: 3em;
  transform: rotate(0deg) skewX(0deg);
}

input:checked + .switch-left::before {
  background-color: transparent;
  width: 3.0833em;
}

input:checked + .switch-left + .switch-right {
  background-color: #ddd;
  color: #888;
  bottom: 0.4em;
  right: 0.8em;
  height: 2.4em;
  width: 2.75em;
  transform: rotate(-15deg) skewX(-15deg);
}

input:checked + .switch-left + .switch-right::before {
  background-color: #ccc;
}

/* Keyboard Users */
input:focus + .switch-left {
  color: #333;
}

input:checked:focus + .switch-left {
  color: #fff;
}

input:focus + .switch-left + .switch-right {
  color: #fff;
}

input:checked:focus + .switch-left + .switch-right {
  color: #333;
}
.preloader {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    z-index: 9;
    background: rgba(0,0,0,0.7);
}
.circular-spinner {
  margin-top: 30px;
  width: 60px;
  height: 60px;
  /* border: 7px solid white;
  border-top: 7px solid #fc0;
  border-radius: 50%; */
  /* animation: rotate 0.5s linear infinite; */
  position: absolute;
  left: 42%;
  top: 45%;
}
.paybridge-task-button { position: fixed; right: 0; top: 190px; z-index: 1040; width: 154px; border: 2px solid rgba(255,255,255,.8); border-radius: 18px 0 0 18px; background: linear-gradient(135deg, #f97316 0%, #dc2626 100%); color: #fff; padding: 9px 11px; display: grid; grid-template-columns: 14px 1fr; align-items: center; gap: 8px; box-shadow: 0 12px 28px rgba(127, 29, 29, .34); cursor: pointer; animation: paybridgeTaskPulse 1.4s ease-in-out infinite; }
.paybridge-task-dot { width: 12px; height: 12px; border-radius: 999px; background: #fde047; box-shadow: 0 0 0 0 rgba(253, 224, 71, .75); animation: paybridgeTaskDot 1.4s ease-in-out infinite; }
.paybridge-task-copy { display: flex; flex-direction: column; align-items: flex-start; line-height: 1.1; text-align: left; }
.paybridge-task-copy strong { color: #fff; font-size: .92rem; font-weight: 900; }
.paybridge-task-copy small { color: #fff7ed; font-size: .75rem; font-weight: 800; }
@keyframes paybridgeTaskPulse { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(-3px); } }
@keyframes paybridgeTaskDot { 0% { box-shadow: 0 0 0 0 rgba(253, 224, 71, .75); } 80%, 100% { box-shadow: 0 0 0 10px rgba(253, 224, 71, 0); } }
@media (max-width: 990px){
  .circular-spinner {
      top: 30%;
      left: 35%;
  }
}
@media (max-width: 660px){
  .circular-spinner {
      top: 30%;
      left: 12%;
  }
  .mobile-dialog2{
    height: 100%;
  }
}
@media (max-width: 991.98px) {
	#registerModal.-with-half-size .-modal-content {
    min-height: 100%;
    height: 100%;
	}
}
.slip-upload-picker {
    position: relative;
    cursor: pointer;
}
.slip-upload-input {
    position: absolute;
    inset: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    cursor: pointer;
}
.slip-upload-input:disabled {
    cursor: not-allowed;
}
.qr-display-image {
    width: 100%;
    height: auto;
    border-radius: 12px;
}
.btn {
    border-radius: 25px;
    color: #000;
    border: none;
    padding: .5rem 1.5rem;
}
/* Bank Transfer Display Styles */
.bank-display-container { padding: 10px; max-width: 380px; margin: 0 auto; }
.bank-card { background: linear-gradient(145deg, #667eea 0%, #764ba2 50%, #6B8DD6 100%); border-radius: 20px; padding: 25px 20px; box-shadow: 0 10px 40px rgba(102, 126, 234, 0.4); color: #fff; position: relative; overflow: hidden; }
.bank-card::before { content: ''; position: absolute; top: -50%; right: -50%; width: 100%; height: 100%; background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%); pointer-events: none; }
.bank-image-wrapper { text-align: center; margin-bottom: 20px; }
.bank-image { width: 90px; height: 90px; border-radius: 50%; object-fit: cover; border: 4px solid rgba(255, 255, 255, 0.9); box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25); background: #fff; }
.account-info { text-align: center; }
.amount-section { background: rgba(255, 255, 255, 0.2); backdrop-filter: blur(10px); border-radius: 16px; padding: 18px; margin-bottom: 18px; border: 1px solid rgba(255, 255, 255, 0.3); }
.amount-label { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 0.85rem; color: rgba(255, 255, 255, 0.95); margin-bottom: 10px; font-weight: 500; }
.account-label { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 0.85rem; color: rgba(255, 255, 255, 0.95); margin-bottom: 6px; font-weight: 500; }
.amount-value { font-size: 1.8rem; font-weight: 700; color: #fff; cursor: pointer; padding: 8px 16px; border-radius: 12px; transition: all 0.3s ease; text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); display: inline-block; }
.amount-value:hover { background: rgba(255, 255, 255, 0.15); transform: scale(1.02); }
.amount-warning { margin-top: 12px; font-size: 0.72rem; color: #ffe066; display: flex; align-items: flex-start; justify-content: center; gap: 6px; line-height: 1.4; padding: 0 10px; }
.account-name-section { background: rgba(255, 255, 255, 0.15); border-radius: 12px; padding: 12px 15px; margin-bottom: 18px; }
.account-name { font-size: 1rem; font-weight: 600; color: #fff; margin-top: 6px; word-break: break-word; }
.account-number { font-size: 1.4rem; font-weight: 700; letter-spacing: 3px; color: #fff; cursor: pointer; padding: 12px 20px; background: rgba(255, 255, 255, 0.2); border-radius: 12px; display: inline-block; margin: 10px 0; transition: all 0.3s ease; border: 2px solid rgba(255, 255, 255, 0.3); }
.account-number:hover { background: rgba(255, 255, 255, 0.3); transform: scale(1.02); }
.copy-button { display: inline-flex; align-items: center; justify-content: center; gap: 8px; background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%); color: #fff; border: none; border-radius: 25px; padding: 12px 24px; font-size: 0.9rem; font-weight: 600; cursor: pointer; transition: all 0.3s ease; margin-top: 12px; box-shadow: 0 4px 15px rgba(0, 176, 155, 0.3); }
.copy-button:hover { transform: translateY(-3px); box-shadow: 0 6px 20px rgba(0, 176, 155, 0.5); }
.copy-amount-button { background: linear-gradient(135deg, #ff6b6b 0%, #feca57 100%); box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3); }
.copy-amount-button:hover { box-shadow: 0 6px 20px rgba(255, 107, 107, 0.5); }
/* PayBridge gold/high-tech deposit display */
.paybridge-panel { width: min(100%, 620px); margin: 0 auto 10px; padding: 16px; color: #0c2130; background: rgba(255,255,255,.82); border: 1px solid rgba(255,255,255,.88); border-radius: 24px; box-shadow: 0 16px 42px rgba(6,54,79,.15); position: relative; overflow: hidden; font-family: 'Kanit', sans-serif; }
.paybridge-panel:before { content: ""; position: absolute; inset: 0; padding: 2px; border-radius: 24px; background: linear-gradient(120deg, rgba(255,255,255,.2), rgba(255,255,255,.96), rgba(245,184,51,.96), rgba(255,255,255,.18), rgba(245,184,51,.82), rgba(255,255,255,.2)); background-size: 240% 240%; -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; animation: paybridgeBorderRun 4.6s linear infinite; z-index: 2; }
.paybridge-panel:after { content: ""; position: absolute; left: 18px; right: 18px; top: 0; height: 1px; background: linear-gradient(90deg, transparent, rgba(255,255,255,.94), rgba(245,184,51,.94), transparent); box-shadow: 0 0 18px rgba(245,184,51,.55); animation: paybridgeTopGlint 2.8s ease-in-out infinite; z-index: 3; }
@keyframes paybridgeBorderRun { 0% { background-position: 0% 50%; } 100% { background-position: 240% 50%; } }
@keyframes paybridgeTopGlint { 0%,100% { opacity:.28; transform: scaleX(.72); } 50% { opacity:.98; transform: scaleX(1); } }
.paybridge-panel-header { text-align: center; background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(237,250,255,.94)); border: 1px solid rgba(16,199,232,.16); border-radius: 18px; padding: 16px 16px 14px; box-shadow: 0 10px 26px rgba(13,82,110,.10); }
.paybridge-badge { display: inline-flex; align-items: center; justify-content: center; gap: 9px; height: 36px; padding: 0 15px; border-radius: 999px; background: linear-gradient(135deg, #052f48, #087f9b); color: #e9fbff; font-weight: 950; font-size: .88rem; box-shadow: 0 14px 24px rgba(6,58,82,.26); }
.paybridge-mark { width: 18px; height: 18px; display: inline-block; border-radius: 7px; background: linear-gradient(135deg, rgba(255,255,255,.85), transparent 42%), linear-gradient(135deg, #f5b833, #10c7e8); box-shadow: 0 0 16px rgba(16,199,232,.58); }
.paybridge-panel-header h3 { margin: 12px 0 5px; color: #0c2130; font-size: 1.45rem; font-weight: 950; line-height: 1.22; }
.paybridge-panel-header p { margin: 0; color: #607684; font-size: .95rem; line-height: 1.45; font-weight: 800; }
.paybridge-route { width: min(280px, 100%); margin: 13px auto 0; display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; color: #0b5c72; font-size: 10px; font-weight: 950; text-transform: uppercase; }
.paybridge-route span { min-height: 24px; display: grid; place-items: center; border-radius: 999px; background: #e8fbff; border: 1px solid #b8eef8; }
.paybridge-agreement-card { display: grid; gap: 12px; margin-top: 14px; padding: 0; background: transparent; color: #0c2130; text-align: left; }
.paybridge-agreement-list { display: grid; gap: 12px; margin: 0; }
.paybridge-agreement-item { display: grid; grid-template-columns: 60px 1fr; align-items: center; gap: 14px; min-height: 82px; padding: 14px 15px; border-radius: 20px; border: 1px solid; position: relative; overflow: hidden; }
.paybridge-agreement-item:after { content: ""; position: absolute; inset: auto 14px 0 88px; height: 1px; background: linear-gradient(90deg, currentColor, transparent); opacity: .18; }
.paybridge-agreement-item.-one { color: #745000; background: linear-gradient(135deg, #fff7d9, #fffdf6); border-color: #ffd66e; }
.paybridge-agreement-item.-two { color: #075d78; background: linear-gradient(135deg, #e8fbff, #fff); border-color: #b8eef8; }
.paybridge-agreement-item.-three { color: #076346; background: linear-gradient(135deg, #e9fff5, #fff); border-color: #bcefd8; }
.paybridge-agreement-item > strong { width: 60px; height: 60px; display: grid; place-items: center; border-radius: 20px; color: #fff; font-size: 31px; font-weight: 1000; box-shadow: 0 12px 20px rgba(0,24,36,.14); }
.paybridge-agreement-item.-one > strong { background: linear-gradient(135deg, #f5b833, #d98600); }
.paybridge-agreement-item.-two > strong { background: linear-gradient(135deg, #10c7e8, #1677ff); }
.paybridge-agreement-item.-three > strong { background: linear-gradient(135deg, #12b981, #07886e); }
.paybridge-agreement-item b { display: block; color: #0c2130; font-size: 1rem; line-height: 1.3; font-weight: 950; }
.paybridge-agreement-item small { display: block; margin-top: 2px; color: currentColor; font-size: .84rem; line-height: 1.35; font-weight: 850; }
.paybridge-agreement-final { margin: 0; padding: 11px 12px; border-radius: 16px; color: #8d2b33; background: linear-gradient(135deg, #fff2f3, #fff8f9); border: 1px solid #ffcdd4; font-size: .88rem; line-height: 1.45; font-weight: 900; text-align: center; }
.paybridge-ack-button, .paybridge-upload-button { width: 100%; min-height: 58px; border: none; border-radius: 18px; background: linear-gradient(135deg, rgba(255,255,255,.18), transparent 42%), linear-gradient(135deg, #0fb879, #087e63); color: #fff; display: inline-flex; align-items: center; justify-content: center; gap: 10px; font-size: 1.04rem; font-weight: 1000; box-shadow: 0 16px 30px rgba(8,126,99,.30), inset 0 0 0 1px rgba(255,255,255,.16); cursor: pointer; transition: transform .15s ease, box-shadow .15s ease; }
.paybridge-cancel-button { width: 100%; min-height: 46px; margin-top: 10px; border-radius: 14px; border: 1px solid #ffd4da; background: #fff4f5; color: #b91c1c; display: inline-flex; align-items: center; justify-content: center; gap: 8px; font-size: .95rem; font-weight: 900; cursor: pointer; }
.paybridge-amount-card { margin: 14px 0; border-radius: 21px; background: linear-gradient(135deg, rgba(255,255,255,.16), transparent 42%), linear-gradient(135deg, #052f48, #1267d6); color: #fff; padding: 15px; display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 12px; box-shadow: 0 15px 30px rgba(18,103,214,.25); }
.paybridge-amount-card span { display: block; color: rgba(255,255,255,.76); font-size: .8rem; font-weight: 850; }
.paybridge-amount-card strong { display: flex; align-items: center; gap: 8px; margin-top: 2px; font-size: 1.55rem; line-height: 1.05; font-weight: 1000; white-space: nowrap; }
.paybridge-timer { min-width: 80px; height: 46px; display: grid; place-items: center; border-radius: 16px; color: #07354f; background: #eafdff; border: 1px solid rgba(255,255,255,.68); font-variant-numeric: tabular-nums; font-size: .95rem; font-weight: 1000; box-shadow: 0 0 0 4px rgba(16,199,232,.12); animation: paybridgeTimerPulse 1.18s ease-in-out infinite; }
@keyframes paybridgeTimerPulse { 0%,100% { background:#eafdff; box-shadow:0 0 0 4px rgba(16,199,232,.12), 0 0 0 0 rgba(245,184,51,0); transform:scale(1); } 42% { background:#fff1b8; box-shadow:0 0 0 4px rgba(245,184,51,.18), 0 0 0 9px rgba(245,184,51,.16); transform:scale(1.035); } 58% { background:#fff8dc; box-shadow:0 0 0 4px rgba(245,184,51,.15), 0 0 0 3px rgba(245,184,51,.10); transform:scale(1.01); } }
.paybridge-account-card { display: grid; grid-template-columns: 64px 1fr; align-items: center; gap: 13px; padding: 15px; border-radius: 21px; background: #fff; box-shadow: 0 14px 30px rgba(6,54,79,.12); border: 1px solid rgba(16,199,232,.22); position: relative; overflow: hidden; }
.paybridge-bank-mark { width: 64px; height: 64px; padding: 8px; border-radius: 19px; background: #f5fbfd; display: flex; align-items: center; justify-content: center; border: 1px solid #dff1f7; }
.paybridge-bank-mark img { width: 100%; height: 100%; object-fit: contain; border-radius: 12px; }
.paybridge-account-detail { min-width: 0; display: flex; flex-direction: column; align-items: flex-start; }
.paybridge-bank-name { color: #607684; font-size: .78rem; font-weight: 900; text-transform: uppercase; }
.paybridge-account-name { color: #0c2130; font-size: 1rem; font-weight: 950; line-height: 1.25; word-break: break-word; }
.paybridge-account-number { margin-top: 5px; display: flex; align-items: center; gap: 8px; color: #087f8f; font-size: 1.42rem; line-height: 1.1; font-weight: 1000; letter-spacing: 0; word-break: break-all; font-variant-numeric: tabular-nums; }
.paybridge-icon-copy { flex: 0 0 auto; width: 34px; height: 34px; display: inline-grid; place-items: center; border-radius: 12px; color: currentColor; background: rgba(255,255,255,.20); border: 1px solid rgba(255,255,255,.54); box-shadow: 0 8px 16px rgba(3,30,48,.12); }
.paybridge-account-number .paybridge-icon-copy { color: #075a74; background: #e8fbff; border-color: #bcebf5; }
.paybridge-critical-warning { margin-top: 14px; padding: 11px; display: grid; grid-template-columns: 30px 1fr; align-items: start; gap: 10px; border-radius: 17px; background: #fff4f5; color: #8d2b33; border: 1px solid #ffd4da; box-shadow: none; }
.paybridge-warning-icon { width: 28px; height: 28px; border-radius: 11px; display: flex; align-items: center; justify-content: center; background: #d84a4f; color: #fff; font-size: .95rem; }
.paybridge-warning-copy { display: flex; flex-direction: column; align-items: flex-start; text-align: left; gap: 3px; }
.paybridge-warning-copy span { font-size: .88rem; font-weight: 850; line-height: 1.45; }
.paybridge-file-input { display: none; }
@media (max-width: 768px) { .bank-display-container { padding: 8px; margin-top: 10px; } .bank-card { padding: 18px 15px; } .bank-image { width: 70px; height: 70px; } .amount-value { font-size: 1.5rem; } .account-number { font-size: 1.2rem; letter-spacing: 2px; padding: 10px 15px; } .copy-button { padding: 10px 18px; font-size: 0.85rem; } }
@media (max-height: 700px) { .bank-image-wrapper { margin-bottom: 12px; } .bank-image { width: 60px; height: 60px; } .amount-section { padding: 12px; margin-bottom: 12px; } .account-name-section { padding: 10px 12px; margin-bottom: 12px; } }

#autopeer_file { display: none; }
.autopeer-deposit-view { max-height: min(68vh, 720px); overflow-y: auto; overscroll-behavior: contain; padding: 0 4px 12px; }
.autopeer-deposit-panel { width: min(94%, 620px); margin: 14px auto 4px; padding: 16px; border-radius: 8px; background: #fff; color: #172033; box-shadow: 0 10px 28px rgba(0,0,0,.20); }
.autopeer-summary { display: grid; grid-template-columns: 1fr auto; gap: 4px 14px; align-items: center; padding-bottom: 12px; border-bottom: 1px solid #e6e9ef; text-align: left; }
.autopeer-kicker { color: #697386; font-size: 14px; }
.autopeer-title { color: #172033; font-size: 24px; font-weight: 700; line-height: 1.2; }
.autopeer-amount { grid-row: 1 / span 2; grid-column: 2; min-width: 110px; padding: 10px 12px; border-radius: 8px; background: #eaf8ef; color: #078a2f; font-size: 27px; font-weight: 800; text-align: center; }
.autopeer-deadline { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 12px; padding: 10px 12px; border-radius: 8px; background: #eef6ff; color: #0f5fb8; font-size: 15px; font-weight: 700; }
.autopeer-deadline.-expired { background: #fff1f1; color: #c42323; }
.autopeer-new-deposit-btn { width: 100%; margin-top: 10px; padding: 11px 14px; border: 0; border-radius: 8px; background: #1e80ff; color: #fff; font-size: 16px; font-weight: 700; }
.autopeer-qr { display: block; width: min(100%, 260px); margin: 14px auto 0; border: 1px solid #e6e9ef; border-radius: 8px; }
.autopeer-detail-card { margin-top: 12px; overflow: hidden; border: 1px solid #e6e9ef; border-radius: 8px; background: #fbfcff; }
.autopeer-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 50px; padding: 11px 13px; border-bottom: 1px solid #e6e9ef; font-size: 18px; text-align: left; }
.autopeer-row:last-child { border-bottom: 0; }
.autopeer-label { flex: 0 0 78px; color: #697386; font-size: 14px; }
.autopeer-bank-value, .autopeer-copy-value { display: flex; align-items: center; justify-content: flex-end; gap: 10px; min-width: 0; text-align: right; }
.autopeer-bank-value strong, .autopeer-copy-value strong { min-width: 0; word-break: break-word; }
.autopeer-bank-logo { flex: 0 0 38px; width: 38px; height: 38px; border: 1px solid #e6e9ef; border-radius: 50%; background: #fff; object-fit: cover; }
.autopeer-ref { min-width: 0; font-size: 15px; text-align: right; word-break: break-word; }
.autopeer-copy-btn { flex: 0 0 auto; padding: 6px 12px; border: 0; border-radius: 8px; background: #1e80ff; color: #fff; font-size: 13px; font-weight: 700; }
.autopeer-upload { display: flex; align-items: center; gap: 12px; margin-top: 14px; padding: 13px; border: 2px dashed #e99a15; border-radius: 8px; background: #fff8e8; color: #5f3700; cursor: pointer; text-align: left; }
.autopeer-upload.-disabled { opacity: .6; cursor: not-allowed; }
.autopeer-upload-icon { display: grid; place-items: center; flex: 0 0 42px; width: 42px; height: 42px; border-radius: 50%; background: #e99a15; color: #fff; font-size: 18px; }
.autopeer-upload-title { font-size: 19px; font-weight: 800; line-height: 1.25; }
.autopeer-upload-subtitle { margin-top: 3px; color: #7a4b09; font-size: 13px; line-height: 1.35; }
.autopeer-status { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 12px; padding: 11px; border-radius: 8px; background: #e8f8ee; color: #087d30; font-size: 14px; font-weight: 700; }
.autopeer-minimum-note { display: flex; align-items: flex-start; justify-content: center; gap: 8px; margin-top: 14px; padding: 10px 12px; border: 1px solid #e99a15; border-radius: 8px; background: #fff7df; color: #8a2f00; font-size: 14px; font-weight: 600; line-height: 1.5; text-align: left; }
.autopeer-minimum-note i { flex: 0 0 auto; margin-top: 3px; color: #d94e00; }
@media (max-width: 560px) {
  .autopeer-deposit-view { max-height: calc(100dvh - 210px); }
  .autopeer-deposit-panel { width: 97%; margin-top: 8px; padding: 13px; }
  .autopeer-summary { grid-template-columns: 1fr; text-align: center; }
  .autopeer-amount { grid-row: auto; grid-column: auto; }
  .autopeer-row { align-items: flex-start; flex-direction: column; gap: 5px; }
  .autopeer-label { flex-basis: auto; }
  .autopeer-bank-value, .autopeer-copy-value { justify-content: space-between; width: 100%; text-align: left; }
  .autopeer-upload-title { font-size: 17px; }
}
</style>
